import { useLocation, useNavigate } from "react-router-dom";
import {
    Box,
    Typography,
    Button,
    Card,
    styled,
    LinearProgress,
    TextField,
    Select,
    MenuItem,
    FormControl,
} from "@mui/material";
import { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import assessmentsData from "./assessmentsData.json";
import { createCustomerAssessmentSession, createKdqol36Score } from "../services/customerAssessment";

const HADS_TAMIL_LANG_DATA = {
    description: "மருத்துவமனை கவலை மற்றும் மனச்சோர்வு அளவுகோல் - 14 கேள்விகள்",
    sub_title: "கவலை மற்றும் மனச்சோர்வு",
    instructions: "கடந்த வாரத்தில் நீங்கள் எப்படி உணர்ந்தீர்கள் என்பதற்கு மிக அருகிலான பதிலைத் தேர்ந்தெடுக்கவும்.",
    questions: [
        {
            question_id: 1,
            question_type: "single_choice",
            question: "நான் பதட்டமாக அல்லது இறுக்கமாக உணர்கிறேன்",
            options: [
                { text: "பெரும்பாலான நேரங்களில்", score: 3, option_id: "a" },
                { text: "நிறைய நேரங்களில்", score: 2, option_id: "b" },
                { text: "அவ்வப்போது", score: 1, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 2,
            question_type: "single_choice",
            question: "முன்பு ரசித்த விஷயங்களை நான் இன்னும் ரசிக்கிறேன்",
            options: [
                { text: "நிச்சயமாக அதே அளவு", score: 0, option_id: "a" },
                { text: "அவ்வளவாக இல்லை", score: 1, option_id: "b" },
                { text: "சிறிதளவு மட்டும்", score: 2, option_id: "c" },
                { text: "கிட்டத்தட்ட இல்லை", score: 3, option_id: "d" },
            ],
        },
        {
            question_id: 3,
            question_type: "single_choice",
            question: "ஏதோ மோசமானது நடக்கப்போகிறது போல பயம் ஏற்படுகிறது",
            options: [
                { text: "மிகவும் தெளிவாகவும் கடுமையாகவும்", score: 3, option_id: "a" },
                { text: "ஆம், ஆனால் அதிகமாக இல்லை", score: 2, option_id: "b" },
                { text: "சிறிது, ஆனால் அது என்னை கவலைப்படுத்தவில்லை", score: 1, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 4,
            question_type: "single_choice",
            question: "நான் சிரிக்கவும் விஷயங்களின் நகைச்சுவையான பக்கத்தைப் பார்க்கவும் முடிகிறது",
            options: [
                { text: "முன்பைப் போலவே", score: 0, option_id: "a" },
                { text: "இப்போது அவ்வளவாக இல்லை", score: 1, option_id: "b" },
                { text: "இப்போது நிச்சயமாக குறைவு", score: 2, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 3, option_id: "d" },
            ],
        },
        {
            question_id: 5,
            question_type: "single_choice",
            question: "கவலைக்குரிய எண்ணங்கள் என் மனதில் ஓடிக்கொண்டிருக்கின்றன",
            options: [
                { text: "மிக அதிக நேரம்", score: 3, option_id: "a" },
                { text: "நிறைய நேரம்", score: 2, option_id: "b" },
                { text: "அவ்வப்போது, ஆனால் அதிகமாக இல்லை", score: 1, option_id: "c" },
                { text: "அரிதாக மட்டும்", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 6,
            question_type: "single_choice",
            question: "நான் மகிழ்ச்சியாக உணர்கிறேன்",
            options: [
                { text: "எதுவும் இல்லை", score: 3, option_id: "a" },
                { text: "அடிக்கடி இல்லை", score: 2, option_id: "b" },
                { text: "சில நேரங்களில்", score: 1, option_id: "c" },
                { text: "பெரும்பாலான நேரங்களில்", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 7,
            question_type: "single_choice",
            question: "நான் அமைதியாக அமர்ந்து தளர்வாக உணர முடிகிறது",
            options: [
                { text: "நிச்சயமாக", score: 0, option_id: "a" },
                { text: "பொதுவாக", score: 1, option_id: "b" },
                { text: "அடிக்கடி இல்லை", score: 2, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 3, option_id: "d" },
            ],
        },
        {
            question_id: 8,
            question_type: "single_choice",
            question: "நான் மெதுவாகிவிட்டேன் போல உணர்கிறேன்",
            options: [
                { text: "கிட்டத்தட்ட எல்லா நேரமும்", score: 3, option_id: "a" },
                { text: "மிகவும் அடிக்கடி", score: 2, option_id: "b" },
                { text: "சில நேரங்களில்", score: 1, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 9,
            question_type: "single_choice",
            question: "வயிற்றில் பட்டாம்பூச்சிகள் பறப்பது போல பயம் ஏற்படுகிறது",
            options: [
                { text: "எதுவும் இல்லை", score: 0, option_id: "a" },
                { text: "அரிதாக", score: 1, option_id: "b" },
                { text: "சற்றே அடிக்கடி", score: 2, option_id: "c" },
                { text: "மிகவும் அடிக்கடி", score: 3, option_id: "d" },
            ],
        },
        {
            question_id: 10,
            question_type: "single_choice",
            question: "என் தோற்றம் பற்றிய ஆர்வத்தை இழந்துவிட்டேன்",
            options: [
                { text: "நிச்சயமாக", score: 3, option_id: "a" },
                { text: "நான் கவனிக்க வேண்டிய அளவு கவனிப்பதில்லை", score: 2, option_id: "b" },
                { text: "சிறிதளவு குறைவாக கவனிக்கலாம்", score: 1, option_id: "c" },
                { text: "முன்பைப் போலவே கவனிக்கிறேன்", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 11,
            question_type: "single_choice",
            question: "நான் தொடர்ந்து அசைய வேண்டும் போல அமைதியின்றி உணர்கிறேன்",
            options: [
                { text: "மிக அதிகமாக", score: 3, option_id: "a" },
                { text: "சற்றே அதிகமாக", score: 2, option_id: "b" },
                { text: "அவ்வளவாக இல்லை", score: 1, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 12,
            question_type: "single_choice",
            question: "நான் விஷயங்களை மகிழ்ச்சியுடன் எதிர்நோக்குகிறேன்",
            options: [
                { text: "முன்பைப் போலவே", score: 0, option_id: "a" },
                { text: "முன்பைவிட சற்றே குறைவு", score: 1, option_id: "b" },
                { text: "முன்பைவிட நிச்சயமாக குறைவு", score: 2, option_id: "c" },
                { text: "கிட்டத்தட்ட இல்லை", score: 3, option_id: "d" },
            ],
        },
        {
            question_id: 13,
            question_type: "single_choice",
            question: "எனக்கு திடீரென பதட்ட உணர்வுகள் வருகின்றன",
            options: [
                { text: "மிகவும் அடிக்கடி", score: 3, option_id: "a" },
                { text: "சற்றே அடிக்கடி", score: 2, option_id: "b" },
                { text: "அவ்வளவாக அடிக்கடி இல்லை", score: 1, option_id: "c" },
                { text: "எதுவும் இல்லை", score: 0, option_id: "d" },
            ],
        },
        {
            question_id: 14,
            question_type: "single_choice",
            question: "நான் நல்ல புத்தகம், ரேடியோ அல்லது டிவி நிகழ்ச்சியை ரசிக்க முடிகிறது",
            options: [
                { text: "அடிக்கடி", score: 0, option_id: "a" },
                { text: "சில நேரங்களில்", score: 1, option_id: "b" },
                { text: "அடிக்கடி இல்லை", score: 2, option_id: "c" },
                { text: "மிக அரிதாக", score: 3, option_id: "d" },
            ],
        },
    ],
};

const EORTC_TAMIL_OPTIONS = [
    { text: "இல்லை", score: 1, option_id: "a" },
    { text: "சிறிதளவு", score: 2, option_id: "b" },
    { text: "மிகவும்", score: 3, option_id: "c" },
    { text: "மிக அதிகமாக", score: 4, option_id: "d" },
];

const EORTC_TAMIL_HEALTH_OPTIONS = [
    { text: "மிக மோசம்", score: 1, option_id: "a" },
    { text: "மோசம்", score: 2, option_id: "b" },
    { text: "சுமார்", score: 3, option_id: "c" },
    { text: "நன்று", score: 4, option_id: "d" },
    { text: "மிக நன்று", score: 5, option_id: "e" },
    { text: "சிறந்தது", score: 6, option_id: "f" },
    { text: "முழுமையானது", score: 7, option_id: "g" },
];

const EORTC_TAMIL_LANG_DATA = {
    description: "EORTC QLQ-C30 - வாழ்க்கைத் தர மதிப்பீடு (30 கேள்விகள்)",
    sub_title: "வாழ்க்கைத் தரம்",
    instructions: "தயவுசெய்து உங்களைப் பற்றிய கீழ்க்கண்ட கேள்விகளுக்கு பதிலளிக்கவும். சரி அல்லது தவறு என்ற பதில்கள் இல்லை.",
    questions: [
        { question_id: 1, question_type: "single_choice", question: "கனமான ஷாப்பிங் பை அல்லது சூட்கேஸ் எடுத்துச் செல்வது போன்ற கடினமான செயல்களைச் செய்வதில் உங்களுக்கு ஏதேனும் சிரமம் உள்ளதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 2, question_type: "single_choice", question: "நீண்ட தூரம் நடப்பதில் உங்களுக்கு ஏதேனும் சிரமம் உள்ளதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 3, question_type: "single_choice", question: "வீட்டிற்கு வெளியே குறுகிய தூரம் நடப்பதில் உங்களுக்கு ஏதேனும் சிரமம் உள்ளதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 4, question_type: "single_choice", question: "பகலில் படுக்கையிலோ நாற்காலியிலோ இருக்க வேண்டிய அவசியம் உங்களுக்கு உள்ளதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 5, question_type: "single_choice", question: "சாப்பிடுதல், உடை அணிதல், குளித்தல் அல்லது கழிப்பறை பயன்படுத்துதல் போன்றவற்றில் உங்களுக்கு உதவி தேவைப்படுகிறதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 6, question_type: "single_choice", question: "உங்கள் வேலை அல்லது பிற தினசரி செயல்களைச் செய்வதில் நீங்கள் கட்டுப்பாடுகளை உணர்ந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 7, question_type: "single_choice", question: "உங்கள் பொழுதுபோக்குகள் அல்லது ஓய்வு நேர செயல்களில் ஈடுபடுவதில் நீங்கள் கட்டுப்பாடுகளை உணர்ந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 8, question_type: "single_choice", question: "உங்களுக்கு மூச்சுத்திணறல் இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 9, question_type: "single_choice", question: "உங்களுக்கு வலி இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 10, question_type: "single_choice", question: "உங்களுக்கு ஓய்வு எடுக்க வேண்டியிருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 11, question_type: "single_choice", question: "உங்களுக்கு தூங்குவதில் சிரமம் இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 12, question_type: "single_choice", question: "நீங்கள் பலவீனமாக உணர்ந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 13, question_type: "single_choice", question: "உங்களுக்கு பசி குறைந்திருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 14, question_type: "single_choice", question: "உங்களுக்கு வாந்தி உணர்வு இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 15, question_type: "single_choice", question: "உங்களுக்கு வாந்தி ஏற்பட்டதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 16, question_type: "single_choice", question: "உங்களுக்கு மலச்சிக்கல் இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 17, question_type: "single_choice", question: "உங்களுக்கு வயிற்றுப்போக்கு இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 18, question_type: "single_choice", question: "நீங்கள் சோர்வாக இருந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 19, question_type: "single_choice", question: "வலி உங்கள் தினசரி செயல்களில் இடையூறு செய்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 20, question_type: "single_choice", question: "செய்தித்தாள் படிப்பது அல்லது தொலைக்காட்சி பார்ப்பது போன்ற விஷயங்களில் கவனம் செலுத்துவதில் உங்களுக்கு சிரமம் இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 21, question_type: "single_choice", question: "நீங்கள் பதட்டமாக உணர்ந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 22, question_type: "single_choice", question: "நீங்கள் கவலைப்பட்டீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 23, question_type: "single_choice", question: "நீங்கள் எரிச்சலாக உணர்ந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 24, question_type: "single_choice", question: "நீங்கள் மனச்சோர்வாக உணர்ந்தீர்களா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 25, question_type: "single_choice", question: "விஷயங்களை நினைவில் வைத்துக்கொள்ள உங்களுக்கு சிரமம் இருந்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 26, question_type: "single_choice", question: "உங்கள் உடல்நிலை அல்லது மருத்துவ சிகிச்சை உங்கள் குடும்ப வாழ்க்கையில் இடையூறு செய்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 27, question_type: "single_choice", question: "உங்கள் உடல்நிலை அல்லது மருத்துவ சிகிச்சை உங்கள் சமூக செயல்களில் இடையூறு செய்ததா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 28, question_type: "single_choice", question: "உங்கள் உடல்நிலை அல்லது மருத்துவ சிகிச்சை உங்களுக்கு நிதி சிரமங்களை ஏற்படுத்தியதா?", options: EORTC_TAMIL_OPTIONS },
        { question_id: 29, question_type: "single_choice", question: "கடந்த வாரத்தில் உங்கள் மொத்த உடல்நலத்தை நீங்கள் எவ்வாறு மதிப்பிடுவீர்கள்?", options: EORTC_TAMIL_HEALTH_OPTIONS },
        { question_id: 30, question_type: "single_choice", question: "கடந்த வாரத்தில் உங்கள் மொத்த வாழ்க்கைத் தரத்தை நீங்கள் எவ்வாறு மதிப்பிடுவீர்கள்?", options: EORTC_TAMIL_HEALTH_OPTIONS },
    ],
};

const uiText = {
    eng: {
        portalTitle: "Clinical Assessment Portal -",
        back: "Back",
        answered: "answered",
        submitAssessment: "Submit Assessment",
        enterAnswer: "Enter your answer",
    },
    tam: {
        portalTitle: "மருத்துவ மதிப்பீட்டு தளம் -",
        back: "திரும்ப",
        answered: "பதிலளிக்கப்பட்டது",
        submitAssessment: "மதிப்பீட்டை சமர்ப்பிக்கவும்",
        enterAnswer: "உங்கள் பதிலை உள்ளிடவும்",
    },
};

const FormContainer = styled(Card)(({ theme }) => ({
    background: "white",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    position: "relative",
    height: "calc(100vh - 60px)",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        width: "0px",
    },
    "&::-webkit-scrollbar-track": {
        background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
        background: "transparent",
    },
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    [theme.breakpoints.down('sm')]: {
        borderRadius: "12px",
        padding: "16px",
        height: "calc(100vh - 40px)",
    },
}));

const OptionBox = styled(Box)(({ selected }) => ({
    border: "1px solid",
    borderColor: selected ? "#2563eb" : "#e5e7eb",
    backgroundColor: selected ? "#2563eb" : "#ffffff",
    color: selected ? "#ffffff" : "#374151",
    borderRadius: "12px",
    padding: "12px 18px",
    cursor: "pointer",
    transition: "all 0.25s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "160px",
    textAlign: "center",
    fontWeight: 500,
    boxShadow: selected
        ? "0 4px 12px rgba(37,99,235,0.3)"
        : "0 1px 4px rgba(0,0,0,0.05)",
    "@media (max-width: 600px)": {
        minWidth: "140px",
        padding: "10px 14px",
        fontSize: "0.85rem",
    },
    "@media (max-width: 400px)": {
        minWidth: "120px",
        padding: "8px 12px",
        fontSize: "0.8rem",
    },
    "&:hover": {
        backgroundColor: selected ? "#1e40af" : "#f9fafb",
        transform: "translateY(-2px)",
    },
}));


const HOURS_12 = Array.from({ length: 12 }, (_, i) => i + 1); // 1..12
const MINUTES_60 = Array.from({ length: 60 }, (_, i) => i);   // 0..59
const AM_PM = ["AM", "PM"];

// assessment id -> question_id -> what that question expects.
const TEXT_ANSWER_VALIDATORS = {
    psqi: {
        1: { type: "time" },                                              // usual bed time
        2: { type: "number", unit: "minutes", min: 0, max: 600 },         // minutes to fall asleep
        3: { type: "time" },                                              // usual wake time
        4: { type: "number", unit: "hours", min: 0, max: 24, step: 0.5 }, // hours actually slept
    },
};

export default function AssessmentForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const storedCustomer = JSON.parse(localStorage.getItem("customer") || "{}");
    const { preferred_language, customer_session_id, customer_id } = storedCustomer;
    const accountId = storedCustomer?.account_id;
    const LANG_CODE_ALIASES = {
        english: "eng",
        en: "eng",
        eng: "eng",
        hindi: "hin",
        hi: "hin",
        hin: "hin",
        kannada: "kan",
        kn: "kan",
        kan: "kan",
        tamil: "tam",
        ta: "tam",
        tam: "tam",
    };
    const normalizeLangCode = (code) => {
        if (!code) return "eng";
        const key = String(code).trim().toLowerCase();
        return LANG_CODE_ALIASES[key] || key;
    };
    const preferredLang = normalizeLangCode(storedCustomer?.preferred_language);
    const [currentLang, setCurrentLang] = useState(preferredLang || "eng");

    const { data: outerData, assessment } = location.state || {};
    const data = outerData?.data || {};
    const status = assessment?.status;
    const [viewingAnswers, setViewingAnswers] = useState(false);
    const isCompleted = status === "completed" || !!data?.value;
    const [answers, setAnswers] = useState({});
    // Per-question validation error text (only ever set for the "number"
    // rule and the generic text fallback - the time picker below can't
    // produce invalid input by construction).
    const [answerErrors, setAnswerErrors] = useState({});
    // In-progress Hour/Minute/AM-PM selections for time questions, kept
    // separate from `answers` so a half-finished pick (hour chosen, minute
    // not yet) doesn't get counted as "answered".
    const [timeDrafts, setTimeDrafts] = useState({});
    const [kdqolScoreResult, setKdqolScoreResult] = useState(null);
    const [hadsScoreResult, setHadsScoreResult] = useState(null); const [psqiScoreResult, setPsqiScoreResult] = useState(null); const [eortcScoreResult, setEortcScoreResult] = useState(null);
        const handleToggle = () => {
        setCurrentLang(prev =>
            prev === preferredLang ? "eng" : preferredLang
        );
    };

    const languageMap = {
        eng: "English",
        hin: "Hindi",
        kan: "Kannada",
        tel: "Telugu",
        ben: "Bengali",
        tam: "Tamil",
    };

    if (data?.value) {
        try {
            const parsed = JSON.parse(data.value);
            console.log("✅ Parsed once:", parsed);

            // If it’s double-stringified
            if (typeof parsed === "string") {
                const parsedTwice = JSON.parse(parsed);
                console.log("✅✅ Parsed twice (final):", parsedTwice);

                parsedTwice.forEach((item) => {
                    console.log(`Question ID: ${item.question_id}, Answer ID: ${item.answer_id}`);
                });
            } else if (Array.isArray(parsed)) {
                parsed.forEach((item) => {
                    console.log(`Question ID: ${item.question_id}, Answer ID: ${item.answer_id}`);
                });
            }
        } catch (err) {
            console.error("❌ Error parsing data.value:", err);
        }
    } else {
        console.warn("⚠️ No data.value found in 'data'");
    }

    // 🧩 Prefill answers if assessment is completed
    useEffect(() => {
        if (status === "completed" && data?.value) {
            try {
                const parsedAnswers = JSON.parse(JSON.parse(data.value));
                console.log("✅ Parsed answers:", parsedAnswers);

                const prefilled = {};
                parsedAnswers.forEach((item) => {
                    prefilled[item.question_id] = item.answer_id;
                });

                setAnswers(prefilled);
            } catch (err) {
                console.error("❌ Error parsing assessment data:", err);
            }
        }
    }, [status, data]);

    if (!assessment) {
        return (
            <Box sx={{ p: 4 }}>
                <Typography variant="h6" sx={{ color: "red" }}>
                    No assessment data found.
                </Typography>
                <Button onClick={() => navigate(-1)} variant="outlined" sx={{ mt: 2 }}>
                    Go Back
                </Button>
            </Box>
        );
    }

    const matchedAssessment =
        assessmentsData[assessment.canonicalTitle || assessment.title];
    if (!matchedAssessment) {
        return (
            <Box sx={{ p: 4 }}>
                <Typography variant="h6" sx={{ color: "red" }}>
                    No data found for this assessment.
                </Typography>
                <Button onClick={() => navigate(-1)} variant="outlined" sx={{ mt: 2 }}>
                    Go Back
                </Button>
            </Box>
        );
    }

    const isHadsAssessment = matchedAssessment?.assessment?.id === "hads";
    const isEortcAssessment = matchedAssessment?.assessment?.id === "eortc";
    const langContent =
        currentLang === "tam" && isHadsAssessment
            ? HADS_TAMIL_LANG_DATA
            : currentLang === "tam" && isEortcAssessment
                ? EORTC_TAMIL_LANG_DATA
            : matchedAssessment.assessment.lang_data[currentLang] ||
            matchedAssessment.assessment.lang_data["eng"];
    const pageText = uiText[currentLang] || uiText.eng;

    const totalQuestions = langContent?.questions?.length || 0;
    const attempted = Object.keys(answers).length;
    const progress = totalQuestions ? (attempted / totalQuestions) * 100 : 0;
    const isKDQOL36 = assessment.key === "kdqol36";
    // Which assessment we're on, used to look up the right entry in
    // TEXT_ANSWER_VALIDATORS (e.g. "psqi").
    const assessmentKey = (assessment?.key || matchedAssessment?.assessment?.id || "").toLowerCase();
    const hasAnswerErrors = Object.values(answerErrors).some(Boolean);
    const assessmentScaleMapping =
        matchedAssessment?.assessment?.scale_mapping ||
        matchedAssessment?.assessment?.score_mapping ||
        {};
    const groupedQuestions = isKDQOL36 ? (() => {
        const groups = {
            "SF-12: Your Health": { questions: [], range: "1–12", color: "#3b82f6" },
            "Burden: Kidney Disease": { questions: [], range: "13–16", color: "#8b5cf6" },
            "Symptoms: Problems": { questions: [], range: "17–28", color: "#ec4899" },
            "Effects: Daily Life": { questions: [], range: "29–36", color: "#f59e0b" }
        };

        langContent?.questions?.forEach((q) => {
            const id = q.question_id;
            if (id <= 12) groups["SF-12: Your Health"].questions.push(q);
            else if (id <= 16) groups["Burden: Kidney Disease"].questions.push(q);
            else if (id <= 28) groups["Symptoms: Problems"].questions.push(q);
            else groups["Effects: Daily Life"].questions.push(q);
        });

        return groups;
    })() : null;

    const handleOptionSelect = (questionId, optionText) => {
        setAnswers((prev) => ({
            ...prev,
            [questionId]: optionText,
        }));
    };

    // Handles the numeric field and the generic text fallback (anything
    // rendered as a plain TextField). Validates on every keystroke.
    const handleTextChange = (question, rawValue) => {
        setAnswers((prev) => ({
            ...prev,
            [question.question_id]: rawValue,
        }));

        const { valid, error } = validateTextAnswer(
            assessmentKey,
            question.question_type,
            question.question_id,
            rawValue
        );

        setAnswerErrors((prev) => ({
            ...prev,
            [question.question_id]: valid ? "" : error,
        }));
    };

    // Handles the Hour / Minute / AM-PM dropdowns for time questions.
    // Because the only inputs possible are the values in HOURS_12 /
    // MINUTES_60 / AM_PM, the result is either a complete valid time or
    // nothing at all - there is no way to end up with "abcd" here.
    const handleTimeChange = (question, part, value) => {
        const current =
            timeDrafts[question.question_id] ||
            parseAnswerToTimeParts(answers[question.question_id]);
        const next = { ...current, [part]: value };

        setTimeDrafts((prev) => ({ ...prev, [question.question_id]: next }));

        const formatted = formatTimeParts(next.hour, next.minute, next.period);
        setAnswers((prev) => {
            const updated = { ...prev };
            if (formatted) {
                updated[question.question_id] = formatted;
            } else {
                // Incomplete selection (e.g. hour picked, minute not yet) -
                // don't count it as "answered" until all three are picked.
                delete updated[question.question_id];
            }
            return updated;
        });

        setAnswerErrors((prev) => ({ ...prev, [question.question_id]: "" }));
    };

   
    const renderValueInput = (q) => {
        const rule = TEXT_ANSWER_VALIDATORS[assessmentKey]?.[q.question_id];

        if (rule?.type === "time") {
            const parts = timeDrafts[q.question_id] || parseAnswerToTimeParts(answers[q.question_id]);
            return (
                <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", alignItems: "center", mt: 1 }}>
                    <FormControl size="small" sx={{ minWidth: 90 }} disabled={isCompleted}>
                        <Select
                            displayEmpty
                            value={parts.hour || ""}
                            onChange={(e) => handleTimeChange(q, "hour", e.target.value)}
                            sx={{ borderRadius: "10px" }}
                        >
                            <MenuItem value="" disabled>Hour</MenuItem>
                            {HOURS_12.map((h) => (
                                <MenuItem key={h} value={h}>{h}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Typography sx={{ fontWeight: 600, color: "#6b7280" }}>:</Typography>

                    <FormControl size="small" sx={{ minWidth: 90 }} disabled={isCompleted}>
                        <Select
                            displayEmpty
                            value={parts.minute === "" || parts.minute === undefined ? "" : parts.minute}
                            onChange={(e) => handleTimeChange(q, "minute", e.target.value)}
                            sx={{ borderRadius: "10px" }}
                        >
                            <MenuItem value="" disabled>Min</MenuItem>
                            {MINUTES_60.map((m) => (
                                <MenuItem key={m} value={m}>{String(m).padStart(2, "0")}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 90 }} disabled={isCompleted}>
                        <Select
                            displayEmpty
                            value={parts.period || ""}
                            onChange={(e) => handleTimeChange(q, "period", e.target.value)}
                            sx={{ borderRadius: "10px" }}
                        >
                            <MenuItem value="" disabled>AM/PM</MenuItem>
                            {AM_PM.map((p) => (
                                <MenuItem key={p} value={p}>{p}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            );
        }

        if (rule?.type === "number") {
            return (
                <TextField
                    fullWidth
                    type="number"
                    variant="outlined"
                    placeholder={`Enter ${rule.unit}`}
                    value={answers[q.question_id] || ""}
                    onChange={!isCompleted ? (e) => handleTextChange(q, e.target.value) : undefined}
                    disabled={isCompleted}
                    error={Boolean(answerErrors[q.question_id])}
                    helperText={answerErrors[q.question_id] || rule.unit}
                    inputProps={{ min: rule.min, max: rule.max, step: rule.step || 1 }}
                    sx={{
                        mt: 1,
                        "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                        "& input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                    }}
                />
            );
        }

        return (
            <TextField
                fullWidth
                variant="outlined"
                placeholder={pageText.enterAnswer}
                value={answers[q.question_id] || ""}
                onChange={!isCompleted ? (e) => handleTextChange(q, e.target.value) : undefined}
                disabled={isCompleted}
                error={Boolean(answerErrors[q.question_id])}
                helperText={answerErrors[q.question_id] || ""}
                sx={{
                    mt: 1,
                    "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                    "& input": { fontSize: { xs: "0.9rem", sm: "1rem" } },
                }}
            />
        );
    };

    const calculateKdqolScoreResult = () => {
        const questions = langContent?.questions || [];
        const sf12Constants = {
            physical: 56.57706,
            mental: 60.75781,
        };
        const sf12Weights = {
            1: { 1: [0, 0], 2: [-1.31872, -0.06064], 3: [-3.02396, 0.03482], 4: [-5.56461, -0.16891], 5: [-8.37399, -1.71175] },
            2: { 1: [-7.23216, 3.93115], 2: [-3.45555, 1.8684], 3: [0, 0] },
            3: { 1: [-6.24397, 2.68282], 2: [-2.73557, 1.43103], 3: [0, 0] },
            4: { 1: [-4.61617, 1.4406], 2: [0, 0] },
            5: { 1: [-5.51747, 1.66968], 2: [0, 0] },
            6: { 1: [3.04365, -6.82672], 2: [0, 0] },
            7: { 1: [2.32091, -5.69921], 2: [0, 0] },
            8: { 1: [0, 0], 2: [-3.8013, 0.90384], 3: [-6.50522, 1.49384], 4: [-8.38063, 1.76691], 5: [-11.25544, 1.48619] },
            9: { 1: [0, 0], 2: [0.66514, -1.94949], 3: [1.36689, -4.09842], 4: [2.37241, -6.31121], 5: [2.90426, -7.92717], 6: [3.46638, -10.19085] },
            10: { 1: [0, 0], 2: [-0.42251, -0.92057], 3: [-1.14387, -1.65178], 4: [-1.6185, -3.29805], 5: [-2.02168, -4.88962], 6: [-2.44706, -6.02409] },
            11: { 1: [4.61446, -16.15395], 2: [3.41593, -10.77911], 3: [2.34247, -8.09914], 4: [1.28044, -4.59055], 5: [0.41188, -1.95934], 6: [0, 0] },
            12: { 1: [-0.33682, -6.29724], 2: [-0.94342, -8.26066], 3: [-0.18043, -5.63286], 4: [0.11038, -3.13896], 5: [0, 0] },
        };

        const getSf12Scores = (questionIds) => {
            let physicalScore = sf12Constants.physical;
            let mentalScore = sf12Constants.mental;
            let answered = 0;

            questionIds.forEach((questionId) => {
                const question = questions.find((q) => q.question_id === questionId);
                const answerId = answers[questionId];
                const selectedOption = question?.options?.find(
                    (option) => option.option_id === answerId
                );

                if (!selectedOption) return;

                const response = Number(selectedOption.score);
                const weights = sf12Weights[questionId]?.[response];
                if (!weights) return;

                physicalScore += weights[0];
                mentalScore += weights[1];
                answered += 1;
            });

            return {
                physicalScore: answered > 0 ? physicalScore : null,
                mentalScore: answered > 0 ? mentalScore : null,
                answered,
                total: questionIds.length,
            };
        };

        const getDomainScore = (questionIds, reverseScore = false) => {
            const answeredItems = questionIds
                .map((questionId) => {
                    const question = questions.find((q) => q.question_id === questionId);
                    const answerId = answers[questionId];
                    const selectedOption = question?.options?.find(
                        (option) => option.option_id === answerId
                    );

                    if (!selectedOption) return null;

                    const scores = question.options.map((option) => Number(option.score));
                    const minScore = Math.min(...scores);
                    const maxScore = Math.max(...scores);
                    const denominator = maxScore - minScore || 1;
                    const rawScore = Number(selectedOption.score);
                    const transformedScore = reverseScore
                        ? ((maxScore - rawScore) / denominator) * 100
                        : ((rawScore - minScore) / denominator) * 100;

                    return transformedScore;
                })
                .filter((score) => score !== null);

            const score = answeredItems.length
                ? answeredItems.reduce((sum, itemScore) => sum + itemScore, 0) / answeredItems.length
                : null;

            return {
                score,
                answered: answeredItems.length,
                total: questionIds.length,
            };
        };

        const sf12 = assessmentScaleMapping.sf12 || [];
        const burden = assessmentScaleMapping.burden || [];
        const symptoms = assessmentScaleMapping.symptoms || [];
        const effects = assessmentScaleMapping.effects || [];
        const sf12Scores = getSf12Scores(sf12);

        return [
            {
                component: "SF-12 Physical Component Summary",
                items: "1-12",
                score: sf12Scores.physicalScore,
                answered: sf12Scores.answered,
                total: sf12Scores.total,
                interpretation: "Higher = better physical health",
                method: "Official SF-12 v1 regression weights",
                note: "Displayed after all 12 SF-12 responses are entered.",
            },
            {
                component: "SF-12 Mental Component Summary",
                items: "1-12",
                score: sf12Scores.mentalScore,
                answered: sf12Scores.answered,
                total: sf12Scores.total,
                interpretation: "Higher = better mental health",
                method: "Official SF-12 v1 regression weights",
                note: "Displayed after all 12 SF-12 responses are entered.",
            },
            {
                component: "Burden of Kidney Disease",
                items: "13-16",
                ...getDomainScore(burden),
                interpretation: "Higher = less perceived burden",
                method: "Mean of transformed answered items",
            },
            {
                component: "Symptoms / Problems",
                items: "17-28",
                ...getDomainScore(symptoms, true),
                interpretation: "Higher = fewer / less severe symptoms",
                method: "Mean of transformed answered items",
            },
            {
                component: "Effects of Kidney Disease",
                items: "29-36",
                ...getDomainScore(effects, true),
                interpretation: "Higher = less impact on daily life",
                method: "Mean of transformed answered items",
            },
        ];
    };

    const parseNumber = (input) => {
    if (input === undefined || input === null) return null;
    const match = String(input).match(/-?\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
};

const parseTimeToMinutes = (input) => {
    if (!input) return null;
    const str = String(input).trim().toLowerCase();
    const match = str.match(/(\d{1,2})[:.]?(\d{2})?\s*(am|pm)?/);
    if (!match) return null;
    let hour = parseInt(match[1], 10);
    const minute = match[2] ? parseInt(match[2], 10) : 0;
    const period = match[3];
    if (isNaN(hour)) return null;
    if (period === "pm" && hour < 12) hour += 12;
    if (period === "am" && hour === 12) hour = 0;
    if (hour > 23) return null;
    return hour * 60 + minute;
};

// Canonical stored format for a time answer built from the dropdowns:
// "H:MM AM/PM", e.g. "10:30 PM". Returns "" while the selection is
// incomplete.
const formatTimeParts = (hour, minute, period) => {
    if (!hour || minute === "" || minute === undefined || minute === null || !period) return "";
    return `${hour}:${String(minute).padStart(2, "0")} ${period}`;
};

// Turns any previously stored answer (whether it was typed freely before
// this change, like "22:30" or "10:30pm", or built by the new dropdowns)
// into { hour, minute, period } for the pickers to display. Reuses
// parseTimeToMinutes so old data still displays correctly.
const parseAnswerToTimeParts = (rawValue) => {
    const totalMinutes = parseTimeToMinutes(rawValue);
    if (totalMinutes === null) return { hour: "", minute: "", period: "" };
    const hour24 = Math.floor(totalMinutes / 60) % 24;
    const minute = totalMinutes % 60;
    const period = hour24 >= 12 ? "PM" : "AM";
    let hour12 = hour24 % 12;
    if (hour12 === 0) hour12 = 12;
    return { hour: hour12, minute, period };
};

// Validates the numeric field and the generic text fallback. Time
// questions never reach this - the dropdown picker can't produce
// anything but a valid time or nothing.
const validateTextAnswer = (assessmentId, questionType, questionId, rawValue) => {
    const value = String(rawValue ?? "").trim();
    if (!value) return { valid: true, error: "" };

    const rule = TEXT_ANSWER_VALIDATORS[assessmentId]?.[questionId];

    if (rule?.type === "number") {
        const num = parseNumber(value);
        if (num === null) {
            return { valid: false, error: `Enter a number of ${rule.unit}` };
        }
        if (
            (rule.min !== undefined && num < rule.min) ||
            (rule.max !== undefined && num > rule.max)
        ) {
            return {
                valid: false,
                error: `Enter a value between ${rule.min} and ${rule.max} ${rule.unit}`,
            };
        }
        return { valid: true, error: "" };
    }

    // No specific rule for this question. "value" questions are meant to
    // hold a measurement, so reject pure text like "abcd". "text"
    // questions are free-form narrative answers, so leave them alone.
    if (questionType === "value" && !/\d/.test(value)) {
        return { valid: false, error: "Please enter a valid answer (numbers only)" };
    }

    return { valid: true, error: "" };
};

    const calculatePsqiScoreResult = () => {
    const questions = langContent?.questions || [];
    const mapping = assessmentScaleMapping || {};

    const getQuestion = (id) => questions.find((q) => q.question_id === id);
    const getLikertScore = (id) => {
        const q = getQuestion(id);
        if (!q) return null;
        const opt = q.options?.find((o) => o.option_id === answers[id]);
        return opt ? Number(opt.score) : null;
    };
    const getTextValue = (id) => {
        const raw = answers[id];
        return raw !== undefined && raw !== null && raw !== "" ? raw : null;
    };
    const isTextQuestion = (id) => {
        const q = getQuestion(id);
        return q?.question_type === "value" || q?.question_type === "text";
    };
    const bucket = (value, ranges) => {
        for (const r of ranges) if (value <= r.max) return r.score;
        return ranges[ranges.length - 1].score;
    };

    // Component 1: Subjective Sleep Quality
    let subjectiveSleepQuality = null;
    (mapping.subjective_sleep_quality || []).forEach((id) => {
        const score = getLikertScore(id);
        if (score !== null) subjectiveSleepQuality = score;
    });

    // Component 2: Sleep Latency
    let latencyMinutes = null;
    let latencyLikert = null;
    (mapping.sleep_latency || []).forEach((id) => {
        if (isTextQuestion(id)) {
            const val = parseNumber(getTextValue(id));
            if (val !== null) latencyMinutes = val;
        } else {
            const score = getLikertScore(id);
            if (score !== null) latencyLikert = score;
        }
    });
    let sleepLatency = null;
    if (latencyMinutes !== null || latencyLikert !== null) {
        const minutesScore = latencyMinutes === null ? 0 : bucket(latencyMinutes, [
            { max: 15, score: 0 }, { max: 30, score: 1 }, { max: 60, score: 2 }, { max: Infinity, score: 3 },
        ]);
        sleepLatency = bucket(minutesScore + (latencyLikert || 0), [
            { max: 0, score: 0 }, { max: 2, score: 1 }, { max: 4, score: 2 }, { max: Infinity, score: 3 },
        ]);
    }

    // Component 3: Sleep Duration
    let hoursSlept = null;
    (mapping.sleep_duration || []).forEach((id) => {
        const val = parseNumber(getTextValue(id));
        if (val !== null) hoursSlept = val;
    });
    let sleepDuration = null;
    if (hoursSlept !== null) {
        sleepDuration = hoursSlept > 7 ? 0 : hoursSlept >= 6 ? 1 : hoursSlept >= 5 ? 2 : 3;
    }

    // Component 4: Habitual Sleep Efficiency
    const efficiencyIds = mapping.habitual_sleep_efficiency || [];
    let bedTimeId = null, wakeTimeId = null;
    efficiencyIds.forEach((id) => {
        const text = (getQuestion(id)?.question || "").toLowerCase();
        if (text.includes("wake") || text.includes("get up") || text.includes("getting up")) wakeTimeId = id;
        else if (text.includes("bed")) bedTimeId = id;
    });
    if (bedTimeId === null && efficiencyIds[0] !== undefined) bedTimeId = efficiencyIds[0];
    if (wakeTimeId === null && efficiencyIds[1] !== undefined) wakeTimeId = efficiencyIds[1];

    const bedMinutes = parseTimeToMinutes(getTextValue(bedTimeId));
    const wakeMinutes = parseTimeToMinutes(getTextValue(wakeTimeId));
    let habitualSleepEfficiency = null;
    let efficiencyPercent = null;
    if (bedMinutes !== null && wakeMinutes !== null && hoursSlept !== null) {
        let timeInBed = wakeMinutes - bedMinutes;
        if (timeInBed <= 0) timeInBed += 24 * 60;
        const timeInBedHours = timeInBed / 60;
        if (timeInBedHours > 0) {
            efficiencyPercent = (hoursSlept / timeInBedHours) * 100;
            habitualSleepEfficiency =
                efficiencyPercent >= 85 ? 0 : efficiencyPercent >= 75 ? 1 : efficiencyPercent >= 65 ? 2 : 3;
        }
    }

    // Component 5: Sleep Disturbances
    let disturbanceSum = 0, disturbanceAnswered = 0;
    (mapping.sleep_disturbances || []).forEach((id) => {
        const score = getLikertScore(id);
        if (score !== null) { disturbanceSum += score; disturbanceAnswered += 1; }
    });
    const sleepDisturbances = disturbanceAnswered > 0 ? bucket(disturbanceSum, [
        { max: 0, score: 0 }, { max: 9, score: 1 }, { max: 18, score: 2 }, { max: Infinity, score: 3 },
    ]) : null;

    // Component 6: Use of Sleeping Medication
    let useOfSleepingMedication = null;
    (mapping.use_of_sleeping_medication || []).forEach((id) => {
        const score = getLikertScore(id);
        if (score !== null) useOfSleepingMedication = score;
    });

    // Component 7: Daytime Dysfunction
    let dysfunctionSum = 0, dysfunctionAnswered = 0;
    (mapping.daytime_dysfunction || []).forEach((id) => {
        const score = getLikertScore(id);
        if (score !== null) { dysfunctionSum += score; dysfunctionAnswered += 1; }
    });
    const daytimeDysfunction = dysfunctionAnswered > 0 ? bucket(dysfunctionSum, [
        { max: 0, score: 0 }, { max: 2, score: 1 }, { max: 4, score: 2 }, { max: Infinity, score: 3 },
    ]) : null;

    const components = [
        { key: "subjectiveSleepQuality", label: "Subjective Sleep Quality", score: subjectiveSleepQuality },
        { key: "sleepLatency", label: "Sleep Latency", score: sleepLatency },
        { key: "sleepDuration", label: "Sleep Duration", score: sleepDuration },
        { key: "habitualSleepEfficiency", label: "Habitual Sleep Efficiency", score: habitualSleepEfficiency },
        { key: "sleepDisturbances", label: "Sleep Disturbances", score: sleepDisturbances },
        { key: "useOfSleepingMedication", label: "Use of Sleeping Medication", score: useOfSleepingMedication },
        { key: "daytimeDysfunction", label: "Daytime Dysfunction", score: daytimeDysfunction },
    ];

    const answeredComponents = components.filter((c) => c.score !== null);
    const globalScore = answeredComponents.length === 7
        ? components.reduce((sum, c) => sum + (c.score || 0), 0)
        : null;

    return { components, answeredComponents: answeredComponents.length, totalComponents: 7, globalScore, efficiencyPercent };
};

    const EORTC_DOMAINS = [
    { key: "physical_functioning", label: "Physical Functioning", short: "PF", reverse: true, interpretation: "Higher = better function" },
    { key: "role_functioning", label: "Role Functioning", short: "RF", reverse: true, interpretation: "Higher = better function" },
    { key: "emotional_functioning", label: "Emotional Functioning", short: "EF", reverse: true, interpretation: "Higher = better function" },
    { key: "cognitive_functioning", label: "Cognitive Functioning", short: "CF", reverse: true, interpretation: "Higher = better function" },
    { key: "social_functioning", label: "Social Functioning", short: "SF", reverse: true, interpretation: "Higher = better function" },
    { key: "global_health_status", label: "Global Health Status/QoL", short: "QL", reverse: false, interpretation: "Higher = better QoL" },
    { key: "fatigue", label: "Fatigue", short: "FA", reverse: false, interpretation: "Higher = worse (more fatigue)" },
    { key: "nausea_vomiting", label: "Nausea and Vomiting", short: "NV", reverse: false, interpretation: "Higher = worse (more nausea/vomiting)" },
    { key: "pain", label: "Pain", short: "PA", reverse: false, interpretation: "Higher = worse (more pain)" },
    { key: "dyspnoea", label: "Dyspnoea", short: "DY", reverse: false, interpretation: "Higher = worse (more breathlessness)" },
    { key: "insomnia", label: "Insomnia", short: "SL", reverse: false, interpretation: "Higher = worse (more sleep trouble)" },
    { key: "appetite_loss", label: "Appetite Loss", short: "AP", reverse: false, interpretation: "Higher = worse (more appetite loss)" },
    { key: "constipation", label: "Constipation", short: "CO", reverse: false, interpretation: "Higher = worse (more constipation)" },
    { key: "diarrhoea", label: "Diarrhoea", short: "DI", reverse: false, interpretation: "Higher = worse (more diarrhoea)" },
    { key: "financial_difficulties", label: "Financial Difficulties", short: "FI", reverse: false, interpretation: "Higher = worse (more financial difficulty)" },
];

const calculateEortcScoreResult = () => {
    const questions = langContent?.questions || [];
    const mapping = assessmentScaleMapping || {};

    const getDomainScore = (questionIds, reverseScore = false) => {
        const answeredItems = (questionIds || [])
            .map((questionId) => {
                const question = questions.find((q) => q.question_id === questionId);
                const answerId = answers[questionId];
                const selectedOption = question?.options?.find((o) => o.option_id === answerId);
                if (!selectedOption) return null;

                const scores = question.options.map((o) => Number(o.score));
                const minScore = Math.min(...scores);
                const maxScore = Math.max(...scores);
                const denominator = maxScore - minScore || 1;
                const rawScore = Number(selectedOption.score);

                return reverseScore
                    ? ((maxScore - rawScore) / denominator) * 100
                    : ((rawScore - minScore) / denominator) * 100;
            })
            .filter((s) => s !== null);

        return {
            score: answeredItems.length ? answeredItems.reduce((s, v) => s + v, 0) / answeredItems.length : null,
            answered: answeredItems.length,
            total: (questionIds || []).length,
        };
    };

    return EORTC_DOMAINS.map((domain) => ({
        ...domain,
        ...getDomainScore(mapping[domain.key], domain.reverse),
    }));
};
    const showKdqolScoreResult = async (allCompleted) => {
        const kdqolScores = calculateKdqolScoreResult();
        const findScore = (component) => kdqolScores.find((item) => item.component === component);
        const sf12Score = findScore("SF-12 Physical Component Summary");
        const burdenScore = findScore("Burden of Kidney Disease");
        const symptomsScore = findScore("Symptoms / Problems");
        const effectsScore = findScore("Effects of Kidney Disease");

        await createKdqol36Score({
            customer_id,
            customer_session_id,
            assessment_type: assessment.key,
            sf12_physical_score: sf12Score?.score,
            sf12_mental_score: findScore("SF-12 Mental Component Summary")?.score,
            burden_score: burdenScore?.score,
            symptoms_score: symptomsScore?.score,
            effects_score: effectsScore?.score,
            sf12_answered: sf12Score?.answered || 0,
            burden_answered: burdenScore?.answered || 0,
            symptoms_answered: symptomsScore?.answered || 0,
            effects_answered: effectsScore?.answered || 0,
            score_summary: kdqolScores,
        });

        setKdqolScoreResult({
            scores: kdqolScores,
            nextPath: allCompleted ? "/music-therapy" : "/my-assessments",
        });
    };
        const calculateScores = async () => {
        const mapping = matchedAssessment?.assessment?.scale_mapping || {};
        const questions = langContent.questions;

        let anxietyScore = 0;
        let depressionScore = 0;
        let totalScore = 0;

        const valueArray = [];
        const type = assessment.key?.toLowerCase();

        console.log("📝 Assessment Type:", type);
        console.log("📌 Scale Mapping:", mapping);

        questions.forEach((q) => {
            const selectedAnswerId = answers[q.question_id];
            if (!selectedAnswerId) return;

            // If question has options
            if (q.options && Array.isArray(q.options)) {
                const selectedOption = q.options.find(
                    (opt) => opt.option_id === selectedAnswerId
                );
                if (!selectedOption) return;

                const score = selectedOption.score;

                valueArray.push({
                    question_id: q.question_id,
                    answer_id: selectedOption.option_id,
                });

                totalScore += score;

                console.log(
                    `Question ${q.question_id} → Option ${selectedOption.option_id} → Score ${score}`
                );

                // ---- HADS ONLY ----
                if (type === "hads") {
                    if (mapping?.anxiety?.includes(q.question_id)) {
                        anxietyScore += score;
                    } else if (mapping?.depression?.includes(q.question_id)) {
                        depressionScore += score;
                    }
                }
            }

            // If answer is a typed text value
            else {
                valueArray.push({
                    question_id: q.question_id,
                    answer_id: selectedAnswerId,
                });

                console.log(
                    `Question ${q.question_id} → Typed Answer: ${selectedAnswerId}`
                );
            }
        });

        // If NOT HADS, remove anxiety/depression
        if (type !== "hads") {
            anxietyScore = null;
            depressionScore = null;
        }

        const isEortc = isEortcAssessment || type === "eortc";
        const eortcDomains = isEortc ? calculateEortcScoreResult().filter((d) => d.answered > 0) : null;
        const eortcGlobalHealth = eortcDomains?.find((d) => d.key === "global_health_status");

        const payload = {
            customer_id,
            customer_session_id,
            assessment_type: assessment.key,
            score: isKDQOL36
                ? null
                : isEortc
                    ? (eortcGlobalHealth?.score != null ? eortcGlobalHealth.score.toFixed(1) : null)
                    : totalScore.toString(),
            anxiety_score: anxietyScore,
            depression_score: depressionScore,
            score_summary: eortcDomains?.length ? eortcDomains : null,
            value: JSON.stringify(valueArray),
        };

        console.log("📦 Final Payload:", payload);

        // ------- API CALL -------
        try {
            const response = await createCustomerAssessmentSession(payload);
            console.log("✅ API Response:", response);

            // ------- UPDATE LOCALSTORAGE -------
            const storedCustomer = JSON.parse(localStorage.getItem("customer") || "{}");

            if (storedCustomer.assessment_type) {
                let assessments = [];

                try {
                    assessments = JSON.parse(storedCustomer.assessment_type);
                } catch (err) {
                    console.error("❌ Failed to parse localStorage assessment_type:", err);
                }

                const updated = assessments.map((a) => {
                    if (
                        a.title?.toLowerCase() === assessment.key?.toLowerCase() ||
                        a.title?.toLowerCase() === assessment.title?.toLowerCase()
                    ) {
                        return { ...a, status: "completed" };
                    }
                    return a;
                });

                storedCustomer.assessment_type = JSON.stringify(updated);
                localStorage.setItem("customer", JSON.stringify(storedCustomer));

                console.log("📝 Updated assessment_type:", updated);
            }

            // ------- CHECK ALL COMPLETED -------
            const updatedCustomer = JSON.parse(localStorage.getItem("customer") || "{}");

            let allCompleted = false;

            if (updatedCustomer?.assessment_type) {
                try {
                    const list = JSON.parse(updatedCustomer.assessment_type);
                    allCompleted = list.every(a => a.status?.toLowerCase() === "completed");

                    console.log("🎯 All Completed:", allCompleted);
                } catch (err) {
                    console.error("❌ Failed parsing updated assessment list:", err);
                }
            }

                    if (isKDQOL36) {
                await showKdqolScoreResult(allCompleted);
                return;
            }

            if (type === "hads") {
                setHadsScoreResult({
                    anxiety: anxietyScore,
                    depression: depressionScore,
                    total: totalScore,
                    nextPath: allCompleted ? "/music-therapy" : "/my-assessments",
                });
                return;
            }

            if (type === "psqi") {
                const psqiResult = calculatePsqiScoreResult();
                setPsqiScoreResult({
                    ...psqiResult,
                    nextPath: allCompleted ? "/music-therapy" : "/my-assessments",
                });
                return;
            }
            if (isEortc) {
                setEortcScoreResult({
                    domains: eortcDomains,
                    nextPath: allCompleted ? "/music-therapy" : "/my-assessments",
                });
                return;
            }

            alert("Assessment submitted successfully!");

            if (allCompleted) {
                navigate("/music-therapy");
            } else {
                navigate("/my-assessments");
            }

        } catch (error) {
            console.error("❌ API Error:", error);
            const errorMessage = String(error?.error || error?.message || "").toLowerCase();
            const alreadySubmitted = errorMessage.includes("already exists");

            if (isKDQOL36 && alreadySubmitted) {
                const updatedCustomer = JSON.parse(localStorage.getItem("customer") || "{}");
                let allCompleted = false;

                if (updatedCustomer?.assessment_type) {
                    try {
                        const list = JSON.parse(updatedCustomer.assessment_type);
                        allCompleted = list.every(a => a.status?.toLowerCase() === "completed");
                    } catch (err) {
                        console.error("❌ Failed parsing updated assessment list:", err);
                    }
                }

                await showKdqolScoreResult(allCompleted);
                return;
            }

            alert("Failed to submit assessment. Please try again.");
        }
    };
        if (hadsScoreResult) {
        const t = {
            eng: { title: "HADS Assessment Result", subtitle: "Summary based on the responses submitted for this assessment.", anxiety: "Anxiety Score", depression: "Depression Score", total: "Total Score", normal: "Normal (0-7)", borderline: "Borderline (8-10)", abnormal: "Abnormal (11-21)", ok: "OK" },
            hin: { title: "HADS मूल्यांकन परिणाम", subtitle: "इस मूल्यांकन में दिए गए उत्तरों के आधार पर सारांश।", anxiety: "चिंता स्कोर", depression: "अवसाद स्कोर", total: "कुल स्कोर", normal: "सामान्य (0-7)", borderline: "सीमा रेखा (8-10)", abnormal: "असामान्य (11-21)", ok: "ठीक है" },
            kan: { title: "HADS ಮೌಲ್ಯಮಾಪನ ಫಲಿತಾಂಶ", subtitle: "ಈ ಮೌಲ್ಯಮಾಪನದಲ್ಲಿ ಸಲ್ಲಿಸಿದ ಉತ್ತರಗಳ ಆಧಾರದ ಮೇಲಿನ ಸಾರಾಂಶ.", anxiety: "ಆತಂಕ ಸ್ಕೋರ್", depression: "ಖಿನ್ನತೆ ಸ್ಕೋರ್", total: "ಒಟ್ಟು ಸ್ಕೋರ್", normal: "ಸಾಮಾನ್ಯ (0-7)", borderline: "ಗಡಿರೇಖೆ (8-10)", abnormal: "ಅಸಾಮಾನ್ಯ (11-21)", ok: "ಸರಿ" },
        };
        const tt = t[currentLang] || t.eng;
        const getBand = (score) => {
            if (score === null || score === undefined) return "-";
            if (score <= 7) return tt.normal;
            if (score <= 10) return tt.borderline;
            return tt.abnormal;
        };
        const cards = [
            { label: tt.anxiety, value: hadsScoreResult.anxiety, band: getBand(hadsScoreResult.anxiety) },
            { label: tt.depression, value: hadsScoreResult.depression, band: getBand(hadsScoreResult.depression) },

        ];

        return (
            <FormContainer sx={{ height: "auto", minHeight: "calc(100vh - 120px)", maxHeight: "calc(100vh - 60px)", overflowY: "auto", p: { xs: 2, sm: 3.5 } }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 2.5, sm: 3 } }}>
                                   <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", sm: "center" },
                            gap: 2,
                            flexWrap: "wrap",
                            borderBottom: "1px solid #e5e7eb",
                            pb: 2,
                        }}
                    >
                        <Box>
                            <Typography variant="h5" sx={{ color: "#111827", fontWeight: 700, fontSize: { xs: "1.35rem", sm: "1.65rem" } }}>
                                {tt.title}
                            </Typography>
                            <Typography sx={{ mt: 0.5, color: "#6b7280", fontSize: { xs: "0.85rem", sm: "0.95rem" } }}>
                                {tt.subtitle}
                            </Typography>
                        </Box>
                        {preferredLang !== "eng" && (
                            <Button
                                variant="contained"
                                onClick={handleToggle}
                                sx={{
                                    bgcolor: "#1976d2",
                                    "&:hover": { bgcolor: "#1565c0" },
                                    borderRadius: 2,
                                    px: { xs: 1.4, sm: 2.5 },
                                    py: { xs: 0.7, sm: 1 },
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {currentLang === "eng" ? languageMap[preferredLang] : "English"}
                            </Button>
                        )}
                    </Box>

                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0,1fr))" }, gap: { xs: 1.5, sm: 2 } }}>
                        {cards.map((c) => (
                            <Box key={c.label} sx={{ backgroundColor: "#eef9f7", border: "1px solid #cbe6e0", borderRadius: "12px", p: { xs: 2, sm: 2.25 }, minHeight: 140, display: "flex", flexDirection: "column", justifyContent: "space-between", boxShadow: "0 2px 8px rgba(15,23,42,0.04)" }}>
                                <Typography sx={{ color: "#111827", fontWeight: 700, fontSize: { xs: "0.95rem", sm: "1rem" } }}>
                                    {c.label}
                                </Typography>
                                <Typography sx={{ color: "#0f2f4f", fontSize: "1.8rem", fontWeight: 800, my: 1.5 }}>
                                    {c.value ?? "-"}
                                </Typography>
                                {c.band && (
                                    <Typography sx={{ color: "#667085", fontWeight: 600, fontSize: "0.9rem" }}>
                                        {c.band}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                        <Button
                            variant="contained"
                            onClick={() => navigate(hadsScoreResult.nextPath)}
                            sx={{ borderRadius: "10px", backgroundColor: "#2563eb", fontWeight: 700, minWidth: { xs: "100%", sm: 160 }, fontSize: "0.95rem", py: 1.1, textTransform: "none", "&:hover": { backgroundColor: "#1e40af" } }}
                        >
                            {tt.ok}
                        </Button>
                    </Box>
                </Box>
            </FormContainer>
        );
    }

    if (psqiScoreResult) {
        const t = {
            eng: { title: "PSQI Assessment Result", subtitle: "Summary based on the responses submitted for this assessment.", global: "Global PSQI Score", goodSleeper: "Good sleep quality (≤5)", poorSleeper: "Poor sleep quality (6-10)", veryPoorSleeper: "Very poor sleep quality (>10)", incomplete: "Score unavailable — not all components could be calculated from the answers given.", answered: "components scored", ok: "OK", components: { subjectiveSleepQuality: "Subjective Sleep Quality", sleepLatency: "Sleep Latency", sleepDuration: "Sleep Duration", habitualSleepEfficiency: "Habitual Sleep Efficiency", sleepDisturbances: "Sleep Disturbances", useOfSleepingMedication: "Use of Sleeping Medication", daytimeDysfunction: "Daytime Dysfunction" } },
            hin: { title: "PSQI मूल्यांकन परिणाम", subtitle: "इस मूल्यांकन में दिए गए उत्तरों के आधार पर सारांश।", global: "कुल PSQI स्कोर", goodSleeper: "अच्छी नींद की गुणवत्ता (≤5)", poorSleeper: "खराब नींद की गुणवत्ता (6-10)", veryPoorSleeper: "बहुत खराब नींद की गुणवत्ता (>10)", incomplete: "स्कोर उपलब्ध नहीं — दिए गए उत्तरों से सभी घटकों की गणना नहीं हो सकी।", answered: "घटकों का स्कोर हुआ", ok: "ठीक है", components: { subjectiveSleepQuality: "व्यक्तिपरक नींद गुणवत्ता", sleepLatency: "नींद आने में देरी", sleepDuration: "नींद की अवधि", habitualSleepEfficiency: "सामान्य नींद दक्षता", sleepDisturbances: "नींद में विघ्न", useOfSleepingMedication: "नींद की दवा का उपयोग", daytimeDysfunction: "दिन में कार्यक्षमता में कमी" } },
            kan: { title: "PSQI ಮೌಲ್ಯಮಾಪನ ಫಲಿತಾಂಶ", subtitle: "ಈ ಮೌಲ್ಯಮಾಪನದಲ್ಲಿ ಸಲ್ಲಿಸಿದ ಉತ್ತರಗಳ ಆಧಾರದ ಮೇಲಿನ ಸಾರಾಂಶ.", global: "ಒಟ್ಟು PSQI ಸ್ಕೋರ್", goodSleeper: "ಉತ್ತಮ ನಿದ್ರೆ ಗುಣಮಟ್ಟ (≤5)", poorSleeper: "ಕಳಪೆ ನಿದ್ರೆ ಗುಣಮಟ್ಟ (6-10)", veryPoorSleeper: "ಅತ್ಯಂತ ಕಳಪೆ ನಿದ್ರೆ ಗುಣಮಟ್ಟ (>10)", incomplete: "ಸ್ಕೋರ್ ಲಭ್ಯವಿಲ್ಲ — ನೀಡಿದ ಉತ್ತರಗಳಿಂದ ಎಲ್ಲಾ ಘಟಕಗಳನ್ನು ಲೆಕ್ಕಹಾಕಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.", answered: "ಘಟಕಗಳು ಸ್ಕೋರ್ ಆಗಿವೆ", ok: "ಸರಿ", components: { subjectiveSleepQuality: "ವ್ಯಕ್ತಿನಿಷ್ಠ ನಿದ್ರೆ ಗುಣಮಟ್ಟ", sleepLatency: "ನಿದ್ರೆ ವಿಳಂಬ", sleepDuration: "ನಿದ್ರೆ ಅವಧಿ", habitualSleepEfficiency: "ರೂಢಿಗತ ನಿದ್ರೆ ದಕ್ಷತೆ", sleepDisturbances: "ನಿದ್ರೆ ಅಡಚಣೆಗಳು", useOfSleepingMedication: "ನಿದ್ರೆ ಔಷಧಿ ಬಳಕೆ", daytimeDysfunction: "ಹಗಲಿನ ಕಾರ್ಯನಿರ್ವಹಣೆ ಕೊರತೆ" } },
        };
               const tt = t[currentLang] || t.eng;
        const globalKnown = psqiScoreResult.globalScore !== null && psqiScoreResult.globalScore !== undefined;
        const psqiBand = !globalKnown ? null : psqiScoreResult.globalScore <= 5 ? "good" : psqiScoreResult.globalScore <= 10 ? "poor" : "veryPoor";
        const bandColors = {
            good: { bg: "#eef9f7", border: "1px solid #cbe6e0" },
            poor: { bg: "#fff7ed", border: "1px solid #fde7c7" },
            veryPoor: { bg: "#fdeeee", border: "1px solid #f2c6c6" },
        };
        const bandText = { good: tt.goodSleeper, poor: tt.poorSleeper, veryPoor: tt.veryPoorSleeper };

        return (
            <FormContainer sx={{ height: "auto", minHeight: "calc(100vh - 120px)", maxHeight: "calc(100vh - 60px)", overflowY: "auto", p: { xs: 2, sm: 3.5 } }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 2.5, sm: 3 } }}>
                                   <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", sm: "center" },
                            gap: 2,
                            flexWrap: "wrap",
                            borderBottom: "1px solid #e5e7eb",
                            pb: 2,
                        }}
                    >
                        <Box>
                            <Typography variant="h5" sx={{ color: "#111827", fontWeight: 700, fontSize: { xs: "1.35rem", sm: "1.65rem" } }}>
                                {tt.title}
                            </Typography>
                            <Typography sx={{ mt: 0.5, color: "#6b7280", fontSize: { xs: "0.85rem", sm: "0.95rem" } }}>
                                {tt.subtitle}
                            </Typography>
                        </Box>
                        {preferredLang !== "eng" && (
                            <Button
                                variant="contained"
                                onClick={handleToggle}
                                sx={{
                                    bgcolor: "#1976d2",
                                    "&:hover": { bgcolor: "#1565c0" },
                                    borderRadius: 2,
                                    px: { xs: 1.4, sm: 2.5 },
                                    py: { xs: 0.7, sm: 1 },
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {currentLang === "eng" ? languageMap[preferredLang] : "English"}
                            </Button>
                        )}
                    </Box>
                                  <Box sx={{ backgroundColor: psqiBand ? bandColors[psqiBand].bg : "#f3f4f6", border: psqiBand ? bandColors[psqiBand].border : "1px solid #e5e7eb", borderRadius: "12px", p: { xs: 2, sm: 2.5 } }}>
                        <Typography sx={{ color: "#111827", fontWeight: 700, fontSize: { xs: "0.95rem", sm: "1rem" } }}>
                            {tt.global}
                        </Typography>
                        <Typography sx={{ color: "#0f2f4f", fontSize: "2.2rem", fontWeight: 800, my: 1 }}>
                            {globalKnown ? psqiScoreResult.globalScore : "-"}
                        </Typography>
                        <Typography sx={{ color: "#667085", fontWeight: 600, fontSize: "0.9rem" }}>
                            {psqiBand
                                ? bandText[psqiBand]
                                : `${tt.incomplete} (${psqiScoreResult.answeredComponents}/${psqiScoreResult.totalComponents} ${tt.answered})`}
                        </Typography>
                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                        <Button
                            variant="contained"
                            onClick={() => navigate(psqiScoreResult.nextPath)}
                            sx={{ borderRadius: "10px", backgroundColor: "#2563eb", fontWeight: 700, minWidth: { xs: "100%", sm: 160 }, fontSize: "0.95rem", py: 1.1, textTransform: "none", "&:hover": { backgroundColor: "#1e40af" } }}
                        >
                            {tt.ok}
                        </Button>
                    </Box>
                </Box>
            </FormContainer>
        );
    }

    if (eortcScoreResult) {
    const t = {
        eng: { title: "EORTC QLQ-C30 Result", subtitle: "Summary based on the responses submitted for this assessment.", answered: "answered", ok: "OK" },
        hin: { title: "EORTC QLQ-C30 परिणाम", subtitle: "इस मूल्यांकन में दिए गए उत्तरों के आधार पर सारांश।", answered: "उत्तर", ok: "ठीक है" },
        ben: { title: "EORTC QLQ-C30 ফলাফল", subtitle: "এই মূল্যায়নে জমা দেওয়া উত্তরের ভিত্তিতে সারাংশ।", answered: "উত্তর দেওয়া হয়েছে", ok: "ঠিক আছে" },
        tel: { title: "EORTC QLQ-C30 ఫలితం", subtitle: "ఈ అంచనాలో సమర్పించిన సమాధానాల ఆధారంగా సారాంశం.", answered: "సమాధానమిచ్చారు", ok: "సరే" },
        kan: { title: "EORTC QLQ-C30 ಫಲಿತಾಂಶ", subtitle: "ಈ ಮೌಲ್ಯಮಾಪನದಲ್ಲಿ ಸಲ್ಲಿಸಿದ ಉತ್ತರಗಳ ಆಧಾರದ ಸಾರಾಂಶ.", answered: "ಉತ್ತರಿಸಲಾಗಿದೆ", ok: "ಸರಿ" },
        tam: { title: "EORTC QLQ-C30 முடிவு", subtitle: "இந்த மதிப்பீட்டில் சமர்ப்பிக்கப்பட்ட பதில்களின் அடிப்படையிலான சுருக்கம்.", answered: "பதிலளிக்கப்பட்டது", ok: "சரி" },
    };
    const tt = t[currentLang] || t.eng;
    const dt = {
    hin: {
        domains: { physical_functioning: "शारीरिक कार्यक्षमता", role_functioning: "भूमिका कार्यक्षमता", emotional_functioning: "भावनात्मक कार्यक्षमता", cognitive_functioning: "संज्ञानात्मक कार्यक्षमता", social_functioning: "सामाजिक कार्यक्षमता", global_health_status: "समग्र स्वास्थ्य स्थिति/जीवन गुणवत्ता", fatigue: "थकान", nausea_vomiting: "मतली और उल्टी", pain: "दर्द", dyspnoea: "सांस फूलना", insomnia: "अनिद्रा", appetite_loss: "भूख में कमी", constipation: "कब्ज", diarrhoea: "दस्त", financial_difficulties: "आर्थिक कठिनाइयाँ" },
        interp: { physical_functioning: "अधिक = बेहतर कार्यक्षमता", role_functioning: "अधिक = बेहतर कार्यक्षमता", emotional_functioning: "अधिक = बेहतर कार्यक्षमता", cognitive_functioning: "अधिक = बेहतर कार्यक्षमता", social_functioning: "अधिक = बेहतर कार्यक्षमता", global_health_status: "अधिक = बेहतर जीवन गुणवत्ता", fatigue: "अधिक = खराब (अधिक थकान)", nausea_vomiting: "अधिक = खराब (अधिक मतली/उल्टी)", pain: "अधिक = खराब (अधिक दर्द)", dyspnoea: "अधिक = खराब (सांस की अधिक तकलीफ)", insomnia: "अधिक = खराब (नींद की अधिक परेशानी)", appetite_loss: "अधिक = खराब (भूख में अधिक कमी)", constipation: "अधिक = खराब (अधिक कब्ज)", diarrhoea: "अधिक = खराब (अधिक दस्त)", financial_difficulties: "अधिक = खराब (अधिक आर्थिक कठिनाई)" },
    },
    ben: {
        domains: { physical_functioning: "শারীরিক কার্যক্ষমতা", role_functioning: "ভূমিকা পালনের কার্যক্ষমতা", emotional_functioning: "আবেগগত কার্যক্ষমতা", cognitive_functioning: "জ্ঞানীয় কার্যক্ষমতা", social_functioning: "সামাজিক কার্যক্ষমতা", global_health_status: "সামগ্রিক স্বাস্থ্য অবস্থা/জীবনের মান", fatigue: "ক্লান্তি", nausea_vomiting: "বমি বমি ভাব ও বমি", pain: "ব্যথা", dyspnoea: "শ্বাসকষ্ট", insomnia: "অনিদ্রা", appetite_loss: "ক্ষুধামান্দ্য", constipation: "কোষ্ঠকাঠিন্য", diarrhoea: "ডায়রিয়া", financial_difficulties: "আর্থিক অসুবিধা" },
        interp: { physical_functioning: "বেশি = ভালো কার্যক্ষমতা", role_functioning: "বেশি = ভালো কার্যক্ষমতা", emotional_functioning: "বেশি = ভালো কার্যক্ষমতা", cognitive_functioning: "বেশি = ভালো কার্যক্ষমতা", social_functioning: "বেশি = ভালো কার্যক্ষমতা", global_health_status: "বেশি = ভালো জীবনের মান", fatigue: "বেশি = খারাপ (বেশি ক্লান্তি)", nausea_vomiting: "বেশি = খারাপ (বেশি বমি বমি ভাব/বমি)", pain: "বেশি = খারাপ (বেশি ব্যথা)", dyspnoea: "বেশি = খারাপ (বেশি শ্বাসকষ্ট)", insomnia: "বেশি = খারাপ (ঘুমের বেশি সমস্যা)", appetite_loss: "বেশি = খারাপ (ক্ষুধা বেশি কমে যাওয়া)", constipation: "বেশি = খারাপ (বেশি কোষ্ঠকাঠিন্য)", diarrhoea: "বেশি = খারাপ (বেশি ডায়রিয়া)", financial_difficulties: "বেশি = খারাপ (বেশি আর্থিক অসুবিধা)" },
    },
    tel: {
        domains: { physical_functioning: "శారీరక పనితీరు", role_functioning: "పాత్ర పనితీరు", emotional_functioning: "భావోద్వేగ పనితీరు", cognitive_functioning: "జ్ఞానాత్మక పనితీరు", social_functioning: "సామాజిక పనితీరు", global_health_status: "మొత్తం ఆరోగ్య స్థితి/జీవన నాణ్యత", fatigue: "అలసట", nausea_vomiting: "వికారం మరియు వాంతులు", pain: "నొప్పి", dyspnoea: "శ్వాస ఆడకపోవడం", insomnia: "నిద్రలేమి", appetite_loss: "ఆకలి తగ్గడం", constipation: "మలబద్ధకం", diarrhoea: "విరేచనాలు", financial_difficulties: "ఆర్థిక ఇబ్బందులు" },
        interp: { physical_functioning: "ఎక్కువ = మెరుగైన పనితీరు", role_functioning: "ఎక్కువ = మెరుగైన పనితీరు", emotional_functioning: "ఎక్కువ = మెరుగైన పనితీరు", cognitive_functioning: "ఎక్కువ = మెరుగైన పనితీరు", social_functioning: "ఎక్కువ = మెరుగైన పనితీరు", global_health_status: "ఎక్కువ = మెరుగైన జీవన నాణ్యత", fatigue: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ అలసట)", nausea_vomiting: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ వికారం/వాంతులు)", pain: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ నొప్పి)", dyspnoea: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ శ్వాస ఇబ్బంది)", insomnia: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ నిద్ర సమస్య)", appetite_loss: "ఎక్కువ = అధ్వాన్నం (ఆకలి ఎక్కువగా తగ్గడం)", constipation: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ మలబద్ధకం)", diarrhoea: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ విరేచనాలు)", financial_difficulties: "ఎక్కువ = అధ్వాన్నం (ఎక్కువ ఆర్థిక ఇబ్బంది)" },
    },
    kan: {
        domains: { physical_functioning: "ದೈಹಿಕ ಕಾರ್ಯಕ್ಷಮತೆ", role_functioning: "ಪಾತ್ರ ಕಾರ್ಯಕ್ಷಮತೆ", emotional_functioning: "ಭಾವನಾತ್ಮಕ ಕಾರ್ಯಕ್ಷಮತೆ", cognitive_functioning: "ಅರಿವಿನ ಕಾರ್ಯಕ್ಷಮತೆ", social_functioning: "ಸಾಮಾಜಿಕ ಕಾರ್ಯಕ್ಷಮತೆ", global_health_status: "ಒಟ್ಟಾರೆ ಆರೋಗ್ಯ ಸ್ಥಿತಿ/ಜೀವನದ ಗುಣಮಟ್ಟ", fatigue: "ಆಯಾಸ", nausea_vomiting: "ವಾಕರಿಕೆ ಮತ್ತು ವಾಂತಿ", pain: "ನೋವು", dyspnoea: "ಉಸಿರಾಟದ ತೊಂದರೆ", insomnia: "ನಿದ್ರಾಹೀನತೆ", appetite_loss: "ಹಸಿವಿನ ಕೊರತೆ", constipation: "ಮಲಬದ್ಧತೆ", diarrhoea: "ಅತಿಸಾರ", financial_difficulties: "ಆರ್ಥಿಕ ತೊಂದರೆಗಳು" },
        interp: { physical_functioning: "ಹೆಚ್ಚು = ಉತ್ತಮ ಕಾರ್ಯಕ್ಷಮತೆ", role_functioning: "ಹೆಚ್ಚು = ಉತ್ತಮ ಕಾರ್ಯಕ್ಷಮತೆ", emotional_functioning: "ಹೆಚ್ಚು = ಉತ್ತಮ ಕಾರ್ಯಕ್ಷಮತೆ", cognitive_functioning: "ಹೆಚ್ಚು = ಉತ್ತಮ ಕಾರ್ಯಕ್ಷಮತೆ", social_functioning: "ಹೆಚ್ಚು = ಉತ್ತಮ ಕಾರ್ಯಕ್ಷಮತೆ", global_health_status: "ಹೆಚ್ಚು = ಉತ್ತಮ ಜೀವನದ ಗುಣಮಟ್ಟ", fatigue: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ಆಯಾಸ)", nausea_vomiting: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ವಾಕರಿಕೆ/ವಾಂತಿ)", pain: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ನೋವು)", dyspnoea: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ಉಸಿರಾಟದ ತೊಂದರೆ)", insomnia: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ನಿದ್ರೆಯ ಸಮಸ್ಯೆ)", appetite_loss: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ಹಸಿವಿನ ಕೊರತೆ)", constipation: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ಮಲಬದ್ಧತೆ)", diarrhoea: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ಅತಿಸಾರ)", financial_difficulties: "ಹೆಚ್ಚು = ಕೆಟ್ಟದು (ಹೆಚ್ಚು ಆರ್ಥಿಕ ತೊಂದರೆ)" },
    },
    tam: {
        domains: { physical_functioning: "உடல் செயல்பாடு", role_functioning: "பங்கு செயல்பாடு", emotional_functioning: "உணர்ச்சி செயல்பாடு", cognitive_functioning: "அறிவாற்றல் செயல்பாடு", social_functioning: "சமூக செயல்பாடு", global_health_status: "ஒட்டுமொத்த உடல்நலம்/வாழ்க்கைத் தரம்", fatigue: "சோர்வு", nausea_vomiting: "குமட்டல் மற்றும் வாந்தி", pain: "வலி", dyspnoea: "மூச்சுத்திணறல்", insomnia: "தூக்கமின்மை", appetite_loss: "பசியின்மை", constipation: "மலச்சிக்கல்", diarrhoea: "வயிற்றுப்போக்கு", financial_difficulties: "நிதி சிரமங்கள்" },
        interp: { physical_functioning: "அதிகம் = சிறந்த செயல்பாடு", role_functioning: "அதிகம் = சிறந்த செயல்பாடு", emotional_functioning: "அதிகம் = சிறந்த செயல்பாடு", cognitive_functioning: "அதிகம் = சிறந்த செயல்பாடு", social_functioning: "அதிகம் = சிறந்த செயல்பாடு", global_health_status: "அதிகம் = சிறந்த வாழ்க்கைத் தரம்", fatigue: "அதிகம் = மோசம் (அதிக சோர்வு)", nausea_vomiting: "அதிகம் = மோசம் (அதிக குமட்டல்/வாந்தி)", pain: "அதிகம் = மோசம் (அதிக வலி)", dyspnoea: "அதிகம் = மோசம் (அதிக மூச்சுத்திணறல்)", insomnia: "அதிகம் = மோசம் (அதிக தூக்கப் பிரச்சனை)", appetite_loss: "அதிகம் = மோசம் (அதிக பசியின்மை)", constipation: "அதிகம் = மோசம் (அதிக மலச்சிக்கல்)", diarrhoea: "அதிகம் = மோசம் (அதிக வயிற்றுப்போக்கு)", financial_difficulties: "அதிகம் = மோசம் (அதிக நிதி சிரமம்)" },
    },
    };
    const dd = dt[currentLang] || {};

    return (
        <FormContainer sx={{ height: "auto", minHeight: "calc(100vh - 120px)", maxHeight: "calc(100vh - 60px)", overflowY: "auto", p: { xs: 2, sm: 3.5 } }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 2.5, sm: 3 } }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, gap: 2, flexWrap: "wrap", borderBottom: "1px solid #e5e7eb", pb: 2 }}>
                    <Box>
                        <Typography variant="h5" sx={{ color: "#111827", fontWeight: 700, fontSize: { xs: "1.35rem", sm: "1.65rem" } }}>{tt.title}</Typography>
                        <Typography sx={{ mt: 0.5, color: "#6b7280", fontSize: { xs: "0.85rem", sm: "0.95rem" } }}>{tt.subtitle}</Typography>
                    </Box>
                    {preferredLang !== "eng" && (
                        <Button variant="contained" onClick={handleToggle} sx={{ bgcolor: "#1976d2", "&:hover": { bgcolor: "#1565c0" }, borderRadius: 2, px: { xs: 1.4, sm: 2.5 }, py: { xs: 0.7, sm: 1 }, textTransform: "none", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.875rem" }, whiteSpace: "nowrap" }}>
                            {currentLang === "eng" ? languageMap[preferredLang] : "English"}
                        </Button>
                    )}
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0,1fr))", lg: "repeat(3, minmax(0,1fr))" }, gap: { xs: 1.5, sm: 2 } }}>
                    {eortcScoreResult.domains.map((d) => (
                        <Box key={d.key} sx={{ backgroundColor: "#eef9f7", border: "1px solid #cbe6e0", borderRadius: "12px", p: { xs: 2, sm: 2.25 }, minHeight: 140, display: "flex", flexDirection: "column", justifyContent: "space-between", boxShadow: "0 2px 8px rgba(15,23,42,0.04)" }}>
                            <Typography sx={{ color: "#111827", fontWeight: 700, fontSize: { xs: "0.9rem", sm: "0.95rem" } }}>{dd.domains?.[d.key] || d.label}</Typography>
                            <Typography sx={{ color: "#0f2f4f", fontSize: "1.8rem", fontWeight: 800, my: 1 }}>{d.score !== null ? d.score.toFixed(1) : "-"}</Typography>
                            <Typography sx={{ color: "#667085", fontWeight: 600, fontSize: "0.8rem" }}>{dd.interp?.[d.key] || d.interpretation}</Typography>
                            <Typography sx={{ color: "#9ca3af", fontWeight: 500, fontSize: "0.78rem", mt: 0.5 }}>{d.answered}/{d.total} {tt.answered}</Typography>
                        </Box>
                    ))}
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                    <Button variant="contained" onClick={() => navigate(eortcScoreResult.nextPath)} sx={{ borderRadius: "10px", backgroundColor: "#2563eb", fontWeight: 700, minWidth: { xs: "100%", sm: 160 }, fontSize: "0.95rem", py: 1.1, textTransform: "none", "&:hover": { backgroundColor: "#1e40af" } }}>
                        {tt.ok}
                    </Button>
                </Box>
            </Box>
        </FormContainer>
    );
}
    if (kdqolScoreResult) {
        const scoreText = {
            eng: {
                title: "KDQOL-36 Component Scores",
                subtitle: "Summary based on the responses submitted for this assessment.",
                higherScores: "Higher scores indicate better reported health",
                answered: "answered",
                ok: "OK",
                headers: ["Component", "Items", "Score (0-100)", "Answered", "Interpretation", "Method"],
                components: {
                    "SF-12 Physical Component Summary": "SF-12 Physical Component Summary",
                    "SF-12 Mental Component Summary": "SF-12 Mental Component Summary",
                    "Burden of Kidney Disease": "Burden of Kidney Disease",
                    "Symptoms / Problems": "Symptoms / Problems",
                    "Effects of Kidney Disease": "Effects of Kidney Disease",
                },
                interpretations: {
                    "Higher = better physical health": "Higher = better physical health",
                    "Higher = better mental health": "Higher = better mental health",
                    "Higher = less perceived burden": "Higher = less perceived burden",
                    "Higher = fewer / less severe symptoms": "Higher = fewer / less severe symptoms",
                    "Higher = less impact on daily life": "Higher = less impact on daily life",
                },
                methods: {
                    "Official SF-12 v1 regression weights": "Official SF-12 v1 regression weights",
                    "Mean of transformed answered items": "Mean of transformed answered items",
                },
            },
            hin: {
                title: "KDQOL-36 घटक स्कोर",
                subtitle: "इस मूल्यांकन में दिए गए उत्तरों के आधार पर सारांश।",
                higherScores: "अधिक स्कोर बेहतर बताई गई स्वास्थ्य स्थिति दर्शाते हैं",
                answered: "उत्तर दिए गए",
                ok: "ठीक है",
                headers: ["घटक", "प्रश्न", "स्कोर (0-100)", "उत्तर", "व्याख्या", "विधि"],
                components: {
                    "SF-12 Physical Component Summary": "SF-12 शारीरिक घटक सारांश",
                    "SF-12 Mental Component Summary": "SF-12 मानसिक घटक सारांश",
                    "Burden of Kidney Disease": "किडनी रोग का बोझ",
                    "Symptoms / Problems": "लक्षण / समस्याएं",
                    "Effects of Kidney Disease": "किडनी रोग के प्रभाव",
                },
                interpretations: {
                    "Higher = better physical health": "अधिक = बेहतर शारीरिक स्वास्थ्य",
                    "Higher = better mental health": "अधिक = बेहतर मानसिक स्वास्थ्य",
                    "Higher = less perceived burden": "अधिक = कम महसूस किया गया बोझ",
                    "Higher = fewer / less severe symptoms": "अधिक = कम / कम गंभीर लक्षण",
                    "Higher = less impact on daily life": "अधिक = दैनिक जीवन पर कम प्रभाव",
                },
                methods: {
                    "Official SF-12 v1 regression weights": "आधिकारिक SF-12 v1 regression weights",
                    "Mean of transformed answered items": "उत्तर दिए गए transformed items का mean",
                },
            },
            kan: {
                title: "KDQOL-36 ಘಟಕ ಸ್ಕೋರ್‌ಗಳು",
                subtitle: "ಈ ಮೌಲ್ಯಮಾಪನದಲ್ಲಿ ಸಲ್ಲಿಸಿದ ಉತ್ತರಗಳ ಆಧಾರದ ಮೇಲಿನ ಸಾರಾಂಶ.",
                higherScores: "ಹೆಚ್ಚಿನ ಸ್ಕೋರ್ ಉತ್ತಮವಾಗಿ ವರದಿಯಾದ ಆರೋಗ್ಯವನ್ನು ಸೂಚಿಸುತ್ತದೆ",
                answered: "ಉತ್ತರಿಸಲಾಗಿದೆ",
                ok: "ಸರಿ",
                headers: ["ಘಟಕ", "ಪ್ರಶ್ನೆಗಳು", "ಸ್ಕೋರ್ (0-100)", "ಉತ್ತರ", "ವ್ಯಾಖ್ಯಾನ", "ವಿಧಾನ"],
                components: {
                    "SF-12 Physical Component Summary": "SF-12 ದೈಹಿಕ ಘಟಕ ಸಾರಾಂಶ",
                    "SF-12 Mental Component Summary": "SF-12 ಮಾನಸಿಕ ಘಟಕ ಸಾರಾಂಶ",
                    "Burden of Kidney Disease": "ಮೂತ್ರಪಿಂಡ ರೋಗದ ಭಾರ",
                    "Symptoms / Problems": "ಲಕ್ಷಣಗಳು / ಸಮಸ್ಯೆಗಳು",
                    "Effects of Kidney Disease": "ಮೂತ್ರಪಿಂಡ ರೋಗದ ಪರಿಣಾಮಗಳು",
                },
                interpretations: {
                    "Higher = better physical health": "ಹೆಚ್ಚು = ಉತ್ತಮ ದೈಹಿಕ ಆರೋಗ್ಯ",
                    "Higher = better mental health": "ಹೆಚ್ಚು = ಉತ್ತಮ ಮಾನಸಿಕ ಆರೋಗ್ಯ",
                    "Higher = less perceived burden": "ಹೆಚ್ಚು = ಕಡಿಮೆ ಅನುಭವಿಸಿದ ಭಾರ",
                    "Higher = fewer / less severe symptoms": "ಹೆಚ್ಚು = ಕಡಿಮೆ / ಕಡಿಮೆ ತೀವ್ರ ಲಕ್ಷಣಗಳು",
                    "Higher = less impact on daily life": "ಹೆಚ್ಚು = ದೈನಂದಿನ ಜೀವನದ ಮೇಲೆ ಕಡಿಮೆ ಪರಿಣಾಮ",
                },
                methods: {
                    "Official SF-12 v1 regression weights": "ಅಧಿಕೃತ SF-12 v1 regression weights",
                    "Mean of transformed answered items": "ಉತ್ತರಿಸಿದ transformed items ಗಳ mean",
                },
            },
        };
        const tScore = scoreText[currentLang] || scoreText.eng;
        const formatScore = (item) => {
            if (item.score !== null) return item.score.toFixed(1);
            return "-";
        };
        const translatedComponent = (item) => tScore.components[item.component] || item.component;
        const translatedInterpretation = (item) => tScore.interpretations[item.interpretation] || item.interpretation;
        const translatedMethod = (item) => tScore.methods[item.method] || item.method;

        return (
            <FormContainer sx={{ height: "auto", minHeight: "calc(100vh - 120px)", maxHeight: "calc(100vh - 60px)", overflowY: "auto", p: { xs: 2, sm: 3.5 } }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 2.5, sm: 3 },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", sm: "center" },
                            gap: 2,
                            flexWrap: "wrap",
                            borderBottom: "1px solid #e5e7eb",
                            pb: 2,
                        }}
                    >
                        <Box>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: "#111827",
                                    fontWeight: 700,
                                    fontSize: { xs: "1.35rem", sm: "1.65rem" },
                                    letterSpacing: 0,
                                }}
                            >
                                {tScore.title}
                            </Typography>
                            <Typography
                                sx={{
                                    mt: 0.5,
                                    color: "#6b7280",
                                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                }}
                            >
                                {tScore.subtitle}
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
                            {preferredLang !== "eng" && (
                                <Button
                                    variant="contained"
                                    onClick={handleToggle}
                                    sx={{
                                        bgcolor: "#1976d2",
                                        "&:hover": { bgcolor: "#1565c0" },
                                        borderRadius: 2,
                                        px: { xs: 1.4, sm: 2.5 },
                                        py: { xs: 0.7, sm: 1 },
                                        textTransform: "none",
                                        fontWeight: 600,
                                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {currentLang === "eng" ? languageMap[preferredLang] : "English"}
                                </Button>
                            )}
                            <Typography
                            sx={{
                                color: "#475467",
                                fontSize: { xs: "0.85rem", sm: "0.95rem" },
                                fontWeight: 600,
                                backgroundColor: "#f3f4f6",
                                border: "1px solid #e5e7eb",
                                borderRadius: "999px",
                                px: 2,
                                py: 0.75,
                            }}
                        >
                                {tScore.higherScores}
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2, minmax(0, 1fr))",
                                lg: "repeat(5, minmax(0, 1fr))",
                            },
                            gap: { xs: 1.5, sm: 2 },
                        }}
                    >
                        {kdqolScoreResult.scores.map((item) => {
                            const isSf12 = item.component.startsWith("SF-12");
                            return (
                                <Box
                                    key={item.component}
                                    sx={{
                                        backgroundColor: isSf12 ? "#f1f6fb" : "#eef9f7",
                                        border: isSf12 ? "1px solid #d4e2f0" : "1px solid #cbe6e0",
                                        borderRadius: "12px",
                                        p: { xs: 2, sm: 2.25 },
                                        minHeight: 150,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#111827",
                                            fontWeight: 700,
                                            fontSize: { xs: "0.95rem", sm: "1rem" },
                                            lineHeight: 1.35,
                                        }}
                                    >
                                        {translatedComponent(item)}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: "#0f2f4f",
                                            fontSize: item.score === null && isSf12 ? "1rem" : "1.8rem",
                                            fontWeight: 800,
                                            my: 1.5,
                                        }}
                                    >
                                        {formatScore(item)}
                                    </Typography>
                                    <Typography sx={{ color: "#667085", fontWeight: 600, fontSize: "0.9rem" }}>
                                        {item.answered} / {item.total} {tScore.answered}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>

                    <Box
                        sx={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: { xs: "300px", sm: "400px" },
                            border: "1px solid #cbd5e1",
                            borderRadius: "10px",
                            boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
                            backgroundColor: "white",
                            "&::-webkit-scrollbar": {
                                width: "0px",
                                height: "0px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: "transparent",
                            },
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                        }}
                    >
                        <Box sx={{ minWidth: { xs: "600px", sm: 980 } }}>
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1.2fr 0.5fr 0.7fr 0.6fr 1.4fr 1.2fr", sm: "1.55fr 0.55fr 0.85fr 0.75fr 1.65fr 1.45fr" },
                                    backgroundColor: "#087e8b",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                }}
                            >
                                {tScore.headers.map((heading) => (
                                    <Typography
                                        key={heading}
                                        sx={{
                                            color: "white",
                                            fontWeight: 700,
                                            px: { xs: 0.5, sm: 1.25 },
                                            py: { xs: 0.5, sm: 1 },
                                            fontSize: { xs: "0.65rem", sm: "0.9rem" },
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {heading}
                                    </Typography>
                                ))}
                            </Box>
                            {kdqolScoreResult.scores.map((item) => (
                                <Box
                                    key={`row-${item.component}`}
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: { xs: "1.2fr 0.5fr 0.7fr 0.6fr 1.4fr 1.2fr", sm: "1.55fr 0.55fr 0.85fr 0.75fr 1.65fr 1.45fr" },
                                        borderTop: "1px solid #e5e7eb",
                                        backgroundColor: "white",
                                        "&:nth-of-type(odd)": { backgroundColor: "#fbfdff" },
                                    }}
                                >
                                    <Typography sx={{ px: { xs: 0.5, sm: 1.25 }, py: { xs: 0.5, sm: 1.1 }, color: "#111827", fontSize: { xs: "0.65rem", sm: "0.9rem" }, lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{translatedComponent(item)}</Typography>
                                    <Typography sx={{ px: { xs: 0.5, sm: 1.25 }, py: { xs: 0.5, sm: 1.1 }, color: "#111827", fontSize: { xs: "0.65rem", sm: "0.9rem" }, lineHeight: 1.2 }}>{item.items}</Typography>
                                    <Typography sx={{ px: { xs: 0.5, sm: 1.25 }, py: { xs: 0.5, sm: 1.15 }, backgroundColor: "#dcf2e5", color: "#0f2f4f", fontWeight: 700, fontSize: { xs: "0.65rem", sm: "0.9rem" } }}>
                                        {formatScore(item)}
                                    </Typography>
                                    <Typography sx={{ px: { xs: 0.5, sm: 1.25 }, py: { xs: 0.5, sm: 1.1 }, color: "#111827", fontSize: { xs: "0.65rem", sm: "0.9rem" }, lineHeight: 1.2 }}>
                                        {item.answered} / {item.total}
                                    </Typography>
                                    <Typography sx={{ px: { xs: 0.5, sm: 1.25 }, py: { xs: 0.5, sm: 1.1 }, color: "#111827", fontSize: { xs: "0.65rem", sm: "0.9rem" }, lineHeight: 1.2, whiteSpace: "normal" }}>{translatedInterpretation(item)}</Typography>
                                    <Typography sx={{ px: { xs: 0.5, sm: 1.25 }, py: { xs: 0.5, sm: 1.1 }, color: "#111827", fontSize: { xs: "0.65rem", sm: "0.9rem" }, lineHeight: 1.2, whiteSpace: "normal" }}>{translatedMethod(item)}</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                        <Button
                            variant="contained"
                            onClick={() => navigate(kdqolScoreResult.nextPath)}
                            sx={{
                                borderRadius: "10px",
                                backgroundColor: "#2563eb",
                                fontWeight: 700,
                                minWidth: { xs: "100%", sm: 160 },
                                fontSize: "0.95rem",
                                py: 1.1,
                                textTransform: "none",
                                "&:hover": { backgroundColor: "#1e40af" },
                            }}
                        >
                            {tScore.ok}
                        </Button>
                    </Box>
                </Box>
            </FormContainer>
        );
    }

    return (
        <FormContainer>
            {/* ✅ Sticky Header Section */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "white",
                    borderBottom: "1px solid #e5e7eb",
                }}
            >
               {/* ---------- HEADER ROW (single line, like desktop) ---------- */}
{/* ---------- HEADER ---------- */}
<Box
    sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        rowGap: 1,
        mb: 1,
    }}
>
    {/* ---------- TITLE (full text, wraps instead of truncating) ---------- */}
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: { xs: 0.5, sm: 1 },
            flex: { xs: "1 1 100%", sm: "0 1 auto" },
        }}
    >
        <Typography
            variant="h6"
            fontWeight={400}
            sx={{ color: "#1f2937", fontSize: { xs: "1rem", sm: "1.25rem" } }}
        >
            {pageText.portalTitle}
        </Typography>

        <Typography
            variant="h6"
            fontWeight={400}
            sx={{ color: "#111827", fontSize: { xs: "1rem", sm: "1.25rem" } }}
        >
            {assessment.title}
        </Typography>
    </Box>

    {/* ---------- BUTTONS (always single row, never stack on each other) ---------- */}
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 0.75, sm: 1 },
            flexWrap: "nowrap",
            flex: { xs: "1 1 100%", sm: "0 0 auto" },
            justifyContent: { xs: "flex-end", sm: "flex-end" },
        }}
    >
        {preferredLang !== "eng" && (
            <Button
                variant="contained"
                onClick={handleToggle}
                sx={{
                    bgcolor: "#1976d2",
                    "&:hover": { bgcolor: "#1565c0" },
                    borderRadius: 2,
                    px: { xs: 1, sm: 2.5 },
                    py: { xs: 0.5, sm: 1 },
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: { xs: "0.7rem", sm: "0.875rem" },
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                }}
            >
                {currentLang === "eng" ? languageMap[preferredLang] : "English"}
            </Button>
        )}

        <Button
            variant="contained"
            onClick={() => navigate("/my-assessments")}
            sx={{
                bgcolor: "#4A90E2",
                "&:hover": { bgcolor: "#357ABD" },
                borderRadius: 2,
                px: { xs: 1, sm: 2.5 },
                py: { xs: 0.5, sm: 1 },
                textTransform: "none",
                fontWeight: 600,
                fontSize: { xs: "0.7rem", sm: "0.875rem" },
                whiteSpace: "nowrap",
                flexShrink: 0,
            }}
        >
            {pageText.back}
        </Button>
    </Box>
</Box>

                <Typography variant="subtitle1" sx={{ color: "#6b7280", mb: 1, fontSize: { xs: "0.85rem", sm: "1rem" } }}>
                    {langContent?.description}
                </Typography>

                <Typography variant="body2" sx={{ color: "#4b5563", mb: 1, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
                    {langContent?.instructions}
                </Typography>

                {/* Progress Bar */}
                <Box>
                    <Typography
                        variant="body2"
                        sx={{ mb: 0.5, color: "#374151", fontWeight: 500, textAlign: "right" }}
                    >
                        {attempted}/{totalQuestions} {pageText.answered}
                    </Typography>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#e5e7eb",
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: "#2563eb",
                                borderRadius: 5,
                            },
                        }}
                    />
                </Box>
            </Box>

            {/* ✅ Scrollable Questions Section */}
            <Box
                sx={{
                    maxHeight: { xs: "calc(100vh - 350px)", sm: "calc(100vh - 280px)" },
                    overflowY: "auto",
                    mt: 2,
                    pr: { xs: 0.5, sm: 1 },
                    "&::-webkit-scrollbar": {
                        width: "0px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "transparent",
                    },
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                }}
            >
                {/* ========== KDQOL-36 WITH SECTIONS ========== */}
                {isKDQOL36 && groupedQuestions ? (
                    Object.entries(groupedQuestions).map(([sectionTitle, sectionData]) => {
                        const sectionAnswered = sectionData.questions.filter(
                            (q) => answers[q.question_id]
                        ).length;
                        const sectionTotal = sectionData.questions.length;
                        const sectionProgress = sectionTotal ? (sectionAnswered / sectionTotal) * 100 : 0;

                        return (
                            <Box key={sectionTitle} sx={{ mb: 4 }}>
                                {/* Section Header */}
                                <Box
                                    sx={{
                                        backgroundColor: sectionData.color,
                                        color: "white",
                                        padding: { xs: "12px 16px", sm: "16px 20px" },
                                        borderRadius: "10px 10px 0 0",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: { xs: 1, sm: 2 },
                                        flexWrap: { xs: "wrap", sm: "nowrap" }
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: { xs: "0.85rem", sm: "1.1rem" }
                                        }}
                                    >
                                        {sectionTitle}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: { xs: "0.75rem", sm: "0.95rem" },
                                            opacity: 0.9
                                        }}
                                    >
                                        {`${sectionAnswered}/${sectionTotal} ${pageText.answered}`}
                                    </Typography>
                                </Box>

                                {/* Section Progress Bar */}
                                <Box sx={{ px: 2, pt: 2, backgroundColor: "#f9fafb" }}>
                                    <LinearProgress
                                        variant="determinate"
                                        value={sectionProgress}
                                        sx={{
                                            height: 8,
                                            borderRadius: 4,
                                            backgroundColor: "#e5e7eb",
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: sectionData.color,
                                                borderRadius: 4,
                                            },
                                        }}
                                    />
                                </Box>

                                {/* Section Questions */}
                                <Box sx={{ backgroundColor: "#f9fafb", px: 2, pb: 2, pt: 1 }}>
                                    {sectionData.questions.map((q, idx) => (
                                        <Box
                                            key={q.question_id}
                                            sx={{
                                                mb: { xs: 2.5, sm: 3 },
                                                p: { xs: 1.5, sm: 2 },
                                                backgroundColor: "white",
                                                borderRadius: "8px",
                                                border: "1px solid #e5e7eb",
                                                boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
                                            }}
                                        >
                                            <Box sx={{ display: "flex", gap: { xs: 1, sm: 2 }, alignItems: "flex-start" }}>
                                                {/* Question Number Circle */}
                                                <Box
                                                    sx={{
                                                        minWidth: { xs: 32, sm: 40 },
                                                        width: { xs: 32, sm: 40 },
                                                        height: { xs: 32, sm: 40 },
                                                        borderRadius: "10px",
                                                        backgroundColor: "#eaf0f7",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: 700,
                                                        color: "#16324f",
                                                        flexShrink: 0,
                                                        fontSize: { xs: "0.85rem", sm: "1rem" }
                                                    }}
                                                >
                                                    {q.question_id}
                                                </Box>
                                                                                            {/* Question Content */}
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: "#1f2937",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            mb: 0.5,
                                                            lineHeight: 1.4
                                                        }}
                                                    >
                                                        {q.question}
                                                    </Typography>

                                                    {q.timeframe && (
                                                        <Typography
                                                            sx={{
                                                                color: "#9ca3af",
                                                                fontSize: { xs: "0.7rem", sm: "0.78rem" },
                                                                fontWeight: 400,
                                                                mb: { xs: 1.5, sm: 2 },
                                                            }}
                                                        >
                                                            {q.timeframe}
                                                        </Typography>
                                                    )}

                                                    {/* Options */}
                                                    {q.question_type === "single_choice" && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                gap: { xs: 1, sm: 1.5 },
                                                                "& > *": {
                                                                    flexBasis: {
                                                                        xs: "calc(50% - 6px)",
                                                                        sm: "auto"
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {q.options.map((opt) => {
                                                                const selected = answers[q.question_id] === opt.option_id;
                                                                return (
                                                                    <Box
                                                                        key={opt.option_id}
                                                                        onClick={() =>
                                                                            !isCompleted &&
                                                                            handleOptionSelect(q.question_id, opt.option_id)
                                                                        }
                                                                        sx={{
                                                                            border: selected ? "2px solid #087e8b" : "1px solid #b9c3cc",
                                                                            backgroundColor: selected ? "#087e8b" : "white",
                                                                            color: selected ? "white" : "#374151",
                                                                            borderRadius: "8px",
                                                                            padding: { xs: "8px 10px", sm: "10px 14px" },
                                                                            cursor: isCompleted ? "default" : "pointer",
                                                                            transition: "all 0.2s ease",
                                                                            fontSize: { xs: "0.75rem", sm: "0.85rem" },
                                                                            fontWeight: selected ? 600 : 500,
                                                                            boxShadow: selected ? "0 2px 7px rgba(8,126,139,0.25)" : "none",
                                                                            "&:hover": {
                                                                                borderColor: "#087e8b",
                                                                                transform: isCompleted ? "none" : "translateY(-1px)"
                                                                            }
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: { xs: "0.75rem", sm: "0.85rem" },
                                                                                fontWeight: 500,
                                                                                textAlign: "center"
                                                                            }}
                                                                        >
                                                                            {opt.text}
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        );
                    })
                ) : (
                    /* ========== DEFAULT QUESTION RENDERING (HADS, PSQI, etc) ========== */
                    <>
                        {langContent?.questions?.map((q) => (
                            <Box
                                key={q.question_id}
                                sx={{
                                    mb: { xs: 2, sm: 4 },
                                    p: { xs: 2, sm: 3 },
                                    borderRadius: 3,
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fafafa",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    fontWeight={500}
                                    sx={{
                                        mb: 2,
                                        color: "#1f2937",
                                        fontSize: { xs: "1rem", sm: "1.1rem" },
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {q.question_id}. {q.question}
                                </Typography>

                                {/* ---------- SINGLE CHOICE ---------- */}
                                {q.question_type === "single_choice" && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: { xs: 1, sm: 2 },
                                            "& > *": {
                                                width: { xs: "100%", sm: "auto" },
                                            },
                                        }}
                                    >
                                        {q.options.map((opt, index) => {
                                            const selected =
                                                answers[q.question_id] === opt.option_id;
                                            return (
                                                <OptionBox
                                                    key={index}
                                                    selected={selected}
                                                    onClick={
                                                        !isCompleted
                                                            ? () =>
                                                                handleOptionSelect(
                                                                    q.question_id,
                                                                    opt.option_id
                                                                )
                                                            : undefined
                                                    }
                                                    sx={{
                                                        cursor: isCompleted ? "default" : "pointer",
                                                        opacity: isCompleted ? 0.7 : 1,
                                                        pointerEvents: isCompleted
                                                            ? "none"
                                                            : "auto",
                                                        p: { xs: 1.5, sm: 2 },
                                                        fontSize: { xs: "0.95rem", sm: "1rem" },
                                                    }}
                                                >
                                                    <Typography variant="body1">
                                                        {opt.text}
                                                    </Typography>
                                                </OptionBox>
                                            );
                                        })}
                                    </Box>
                                )}

                                {/* ---------- VALUE / TEXT INPUT (time picker, number field, or free text) ---------- */}
                                {(q.question_type === "value" || q.question_type === "text") &&
                                    renderValueInput(q)}
                            </Box>
                        ))}
                    </>
                )}

                {/* ---------- SUBMIT BUTTON ---------- */}
                {status !== "completed" && (
                    <Button
                        variant="contained"
                        fullWidth
                        disabled={
                            isKDQOL36
                                ? attempted === 0 || hasAnswerErrors
                                : attempted !== totalQuestions || hasAnswerErrors
                        }
                        sx={{
                            borderRadius: "12px",
                            backgroundColor:
                                isKDQOL36
                                    ? (attempted > 0 && !hasAnswerErrors ? "#2563eb" : "#9ca3af")
                                    : (attempted === totalQuestions && !hasAnswerErrors ? "#2563eb" : "#9ca3af"),
                            fontWeight: 600,
                            fontSize: { xs: "0.9rem", sm: "1rem" },
                            py: { xs: 1.2, sm: 1.2 },
                            mt: 2,
                            mb: 2,
                            textTransform: "none",
                            "&:hover": {
                                backgroundColor:
                                    isKDQOL36
                                        ? (attempted > 0 && !hasAnswerErrors ? "#1e40af" : "#9ca3af")
                                        : (attempted === totalQuestions && !hasAnswerErrors ? "#1e40af" : "#9ca3af"),
                            },
                        }}
                        onClick={() => {
                            const canSubmit = isKDQOL36 ? attempted > 0 : attempted === totalQuestions;
                            if (canSubmit && !hasAnswerErrors) {
                                calculateScores();
                            }
                        }}
                    >
                        {pageText.submitAssessment}
                    </Button>
                )}
            </Box>

        </FormContainer>

    );
}